 import { BundledialogComponent } from "./pages/bundledialog/bundledialog.component";
import {
  AfterViewInit,
  Component,
  HostListener,
  Inject,
  OnDestroy,
  OnInit,
  VERSION,
  ViewChild,
  ElementRef,
  ChangeDetectorRef,
} from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { ActivatedRoute, Route, Router, NavigationEnd } from "@angular/router";
import { DataService } from "src/app/Services/dataservice.service";
import { FlowServiceService } from "./Services/flow-service.service";
import { UserserviceService } from "./Services/userservice.service";

import { EventEmitterService } from "./Services/event-emitter.service";
import { PermissionsService } from "./Services/permissions.service";
import { UntypedFormControl } from "@angular/forms";
import { map, startWith, filter, switchMap, catchError } from "rxjs/operators";
import { Observable, partition, Subject, of, merge, Subscription } from "rxjs";
import { debounceTime, distinctUntilChanged } from "rxjs/operators";
import { ToastrService } from "ngx-toastr";
import { Location } from "@angular/common";
import { MatDialog, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { AuthService } from "./Services/auth.service";
import { TokenService } from "./Services/token.service";
import { SubscriptionUsageAlertService } from "./Services/subscription-usage-alert.service";
import { FlowQueryModel } from "./models/flowquerymodel";
import { getConsultationDashboardPath } from "./utils/consultation-notification-nav.util";
import {
  shouldAvatarOpenProfile,
} from "./utils/notification-avatar-nav.util";
import { FrontlineGlossary } from "./shared/constants/frontline-glossary";
import { DeleteUserDialogComponent } from "./pages/delete-user-dialog/delete-user-dialog.component";
import { RequestAccessComponent } from "./pages/request-access/request-access.component";
import { AccessRoleInfoComponent } from "./pages/access-role-info/access-role-info.component";
import { SearchHistoryService } from "./Services/search-history.service";
import { AuthModalService, AuthModalType } from "./Services/auth-modal.service";
import { TranslationService } from "./Services/translation.service";
import { ItemLibraryService, ItemLibraryModel } from "./Services/item-library.service";
import { COMMA } from "@angular/cdk/keycodes";
import { MatChipInputEvent } from "@angular/material/chips";
import { ThemePreferenceService, ThemeMode } from "./Services/theme-preference.service";
import { OrgContextService } from "./Services/org-context.service";
import { OrgNotificationService } from "./Services/org-notification.service";
import { TrialStateService } from "./Services/trial-state.service";
import {
  dismissPaymentFailure,
  getUndismissedPaymentFailure,
  isTrialActive,
  PAYPAL_AUTOPAY_URL,
} from "./shared/utils/trial.util";
import { isSiteAdminUser } from "./shared/site-admin.util";
declare var firebase: any;
declare var gtag: any;
// declare ga as a function to set and sent the events
declare let ga: any;

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
})
export class AppComponent implements OnInit, AfterViewInit, OnDestroy {
  /** Frontline Keep glossary — display only; category keys stay Flows/Bundles. */
  readonly glossary = FrontlineGlossary;
  orgLogoUrl: string | null = null;
  orgName: string | null = null;
  hasOrgBranding = false;
  orgApplications: any[] = [];
  orgTeams: any[] = [];
  activeApplicationId: string | null = null;
  activeTeamId: string | null = null;
  showOrgSwitcher = false;
  /** Public account type is always available in the switcher. */
  showPublicAccountType = true;
  orgMembershipChips: { role?: string; jobRole?: string; label: string }[] = [];
  /** Highest access role in the active organization (shown in header / menus). */
  orgRoleSummary: string | null = null;
  accountTypeOrgOptions: {
    organizationId: string;
    organizationName: string;
    roleLabel?: string;
  }[] = [];
  selectedAccountTypeValue = "public";
  private orgContextWatchSub: Subscription | null = null;
  /** Account scope (public / org id) the bell notifications were last fetched for. */
  private notificationsScopeKey: string | null = null;

  public repoUrl: string;
  today: Date = new Date();
  yesterday: Date = new Date();
  thisWeekStart: Date = new Date();
  notificationsToday: any[] = [];
  notificationsYesterday: any[] = [];
  notificationsThisWeek: any[] = [];
  notificationsOlder: any[] = [];
  myControl = new UntypedFormControl();
  options: string[] = [
    "Guide 1",
    "Guide 2",
    "Guide 3",
    "Guide 4",
    "Guide 5",
    "Guide 6",
    "Guide 7",
    "Guide 8",
    "Guide 9",
    "Guide 10",
  ];
  filteredOptions: Observable<string[]>;

  qrcodename: string;
  title = "generate-qrcode";
  // elementType: 'url' | 'canvas' | 'img' = 'url';
  value: string;
  display = false;
  href: string;

  // ename = 'Angular' +VERSION.major;

  // correctionLevel = NgxQrcodeErrorCorrectionLevels.HIGH;
  // value='https://flowchest.azurewebsites.net/grid';

  isLogin = false;
  message;
  notificationtitle: any;
  notificationbody: any;
  notificationsarray: any[] = [];
  notificationscount: number;
  showNotificationCount: boolean;
  flows: any;
  currentImage: any;
  previousIndex: any;
  showImg = false;
  arrow = false;
  itemCount = 0;
  scrHeight: any;
  scrWidth: any;
  SlideOptions: any;
  profilePicture: string;
  userDisplayName: any;
  userData: any;
  showDefaultImage: boolean;
  email: any;
  phone: any;
  info: any;
  website: any;
  uname: any;
  name: any;
  isAdmin: any;
  categories: any[] = [];

  homebgColor: any;
  homeColor: any;

  searchbgColor: any;
  searchColor: any;

  emoji_objectsbgColor: any;
  emoji_objectsColor: any;

  add_circle_outlinebgColor: any;
  add_circle_outlineColor: any;

  notificationsbgColor: any;
  notificationsColor: any;

  profilebgColor: any;
  profileColor: any;
  turnOnNightMode: string;
  selectedThemeMode: "light" | "dark" = "light";
  menubgColor: any;
  menuColor: any;

  langList: any[] = [
    { value: "en", display: "English" },
    { value: "tr", display: "Turkish" },
  ];
  account_circleColor: string;
  account_circlebgColor: string;
  personColor: string;
  personbgColor: string;
  getNotificationUrl: string;
  userDisplayEmail: any;
  ProfilePicUrl: any;
  noResultReturned: boolean;
  tempNotifications: any = [];
  infiniteScrollCount: number;
  isMobileView: boolean;
  add_circle_outlineSize: any;
  isthereanyNotifications: boolean;
  isuserdashboard: boolean;
  profile_outlineSize: string;
  account_border: string;
  account_borderRadius: string;
  notifications: boolean;
  isUserLoggedIn!: boolean;
  canViewNotification: boolean = true;
  /** Access flag for create/edit (Create stays visible; this gates openDialog / routes). */
  canCreateFlowOrBundle: boolean = true;
  canViewUserDashBoard: boolean = true;
  /** Org admin menu (accessOrgAdmin feature). */
  canAccessOrgAdmin: boolean = false;
  /** Org setup menu (manageOrganization feature, or first-time org creation). */
  canAccessOrgSetup: boolean = false;
  /** Creator chrome: Dashboard, collab — false for Worker end-users. */
  canAccessCreatorChrome: boolean = true;
  /** No Active membership — show Join apps entry. */
  showOrgJoinDiscover: boolean = false;
  premissionToActions: { [permission: string]: boolean } = {};
  activeHomeCategory: 'Flows' | 'Users' | 'Bundles' | 'Items' = 'Flows';

  // Google Translate
  @ViewChild("googleTranslateHeader", { static: false })
  googleTranslateHeader: ElementRef;
  // Note: legacy mobile-specific translate container has been removed, but we
  // keep these flags to satisfy any remaining legacy logic safely.
  private googleTranslateInitialized: boolean = false;
  private mobileTranslateInitialized: boolean = false;
  private performanceIntervals: ReturnType<typeof setInterval>[] = [];
  private performanceObservers: MutationObserver[] = [];
  private translateUiSyncTimeout: ReturnType<typeof setTimeout> | null = null;
  private translateBannerSyncTimeout: ReturnType<typeof setTimeout> | null = null;
  showMobileTranslate: boolean = false;
  isTranslateBannerCollapsed: boolean = false; // Default to visible (expanded)
  isHeaderTranslateExpanded: boolean = false;
  selectedLanguage: string = null;
  selectedLanguageName: string = null;
  showDesktopLanguageModal: boolean = false;

  // Full Google language list for modal (code + display name)
  languageOptions: { code: string; name: string }[] = [
    { code: "", name: "Select Language" },
    { code: "ab", name: "Abkhaz" },
    { code: "ace", name: "Acehnese" },
    { code: "ach", name: "Acholi" },
    { code: "aa", name: "Afar" },
    { code: "af", name: "Afrikaans" },
    { code: "sq", name: "Albanian" },
    { code: "alz", name: "Alur" },
    { code: "am", name: "Amharic" },
    { code: "ar", name: "Arabic" },
    { code: "hy", name: "Armenian" },
    { code: "as", name: "Assamese" },
    { code: "av", name: "Avar" },
    { code: "awa", name: "Awadhi" },
    { code: "ay", name: "Aymara" },
    { code: "az", name: "Azerbaijani" },
    { code: "ban", name: "Balinese" },
    { code: "bal", name: "Baluchi" },
    { code: "bm", name: "Bambara" },
    { code: "bci", name: "Baoulé" },
    { code: "ba", name: "Bashkir" },
    { code: "eu", name: "Basque" },
    { code: "btx", name: "Batak Karo" },
    { code: "bts", name: "Batak Simalungun" },
    { code: "bbc", name: "Batak Toba" },
    { code: "be", name: "Belarusian" },
    { code: "bem", name: "Bemba" },
    { code: "bn", name: "Bengali" },
    { code: "bew", name: "Betawi" },
    { code: "bho", name: "Bhojpuri" },
    { code: "bik", name: "Bikol" },
    { code: "bs", name: "Bosnian" },
    { code: "br", name: "Breton" },
    { code: "bg", name: "Bulgarian" },
    { code: "bua", name: "Buryat" },
    { code: "yue", name: "Cantonese" },
    { code: "ca", name: "Catalan" },
    { code: "ceb", name: "Cebuano" },
    { code: "ch", name: "Chamorro" },
    { code: "ce", name: "Chechen" },
    { code: "ny", name: "Chichewa" },
    { code: "zh-CN", name: "Chinese (Simplified)" },
    { code: "zh-TW", name: "Chinese (Traditional)" },
    { code: "chk", name: "Chuukese" },
    { code: "cv", name: "Chuvash" },
    { code: "co", name: "Corsican" },
    { code: "crh", name: "Crimean Tatar (Cyrillic)" },
    { code: "crh-Latn", name: "Crimean Tatar (Latin)" },
    { code: "hr", name: "Croatian" },
    { code: "cs", name: "Czech" },
    { code: "da", name: "Danish" },
    { code: "fa-AF", name: "Dari" },
    { code: "dv", name: "Dhivehi" },
    { code: "din", name: "Dinka" },
    { code: "doi", name: "Dogri" },
    { code: "dov", name: "Dombe" },
    { code: "nl", name: "Dutch" },
    { code: "dyu", name: "Dyula" },
    { code: "dz", name: "Dzongkha" },
    { code: "eo", name: "Esperanto" },
    { code: "et", name: "Estonian" },
    { code: "ee", name: "Ewe" },
    { code: "fo", name: "Faroese" },
    { code: "fj", name: "Fijian" },
    { code: "tl", name: "Filipino" },
    { code: "fi", name: "Finnish" },
    { code: "fon", name: "Fon" },
    { code: "fr", name: "French" },
    { code: "fr-CA", name: "French (Canada)" },
    { code: "fy", name: "Frisian" },
    { code: "fur", name: "Friulian" },
    { code: "ff", name: "Fulani" },
    { code: "gaa", name: "Ga" },
    { code: "gl", name: "Galician" },
    { code: "ka", name: "Georgian" },
    { code: "de", name: "German" },
    { code: "el", name: "Greek" },
    { code: "gn", name: "Guarani" },
    { code: "gu", name: "Gujarati" },
    { code: "ht", name: "Haitian Creole" },
    { code: "cnh", name: "Hakha Chin" },
    { code: "ha", name: "Hausa" },
    { code: "haw", name: "Hawaiian" },
    { code: "iw", name: "Hebrew" },
    { code: "hil", name: "Hiligaynon" },
    { code: "hi", name: "Hindi" },
    { code: "hmn", name: "Hmong" },
    { code: "hu", name: "Hungarian" },
    { code: "hrx", name: "Hunsrik" },
    { code: "iba", name: "Iban" },
    { code: "is", name: "Icelandic" },
    { code: "ig", name: "Igbo" },
    { code: "ilo", name: "Ilocano" },
    { code: "id", name: "Indonesian" },
    { code: "iu-Latn", name: "Inuktut (Latin)" },
    { code: "iu", name: "Inuktut (Syllabics)" },
    { code: "ga", name: "Irish Gaelic" },
    { code: "it", name: "Italian" },
    { code: "jam", name: "Jamaican Patois" },
    { code: "ja", name: "Japanese" },
    { code: "jw", name: "Javanese" },
    { code: "kac", name: "Jingpo" },
    { code: "kl", name: "Kalaallisut" },
    { code: "kn", name: "Kannada" },
    { code: "kr", name: "Kanuri" },
    { code: "pam", name: "Kapampangan" },
    { code: "kk", name: "Kazakh" },
    { code: "kha", name: "Khasi" },
    { code: "km", name: "Khmer" },
    { code: "cgg", name: "Kiga" },
    { code: "kg", name: "Kikongo" },
    { code: "rw", name: "Kinyarwanda" },
    { code: "ktu", name: "Kituba" },
    { code: "trp", name: "Kokborok" },
    { code: "kv", name: "Komi" },
    { code: "gom", name: "Konkani" },
    { code: "ko", name: "Korean" },
    { code: "kri", name: "Krio" },
    { code: "ku", name: "Kurdish (Kurmanji)" },
    { code: "ckb", name: "Kurdish (Sorani)" },
    { code: "ky", name: "Kyrgyz" },
    { code: "lo", name: "Lao" },
    { code: "ltg", name: "Latgalian" },
    { code: "la", name: "Latin" },
    { code: "lv", name: "Latvian" },
    { code: "lij", name: "Ligurian" },
    { code: "li", name: "Limburgish" },
    { code: "ln", name: "Lingala" },
    { code: "lt", name: "Lithuanian" },
    { code: "lmo", name: "Lombard" },
    { code: "lg", name: "Luganda" },
    { code: "luo", name: "Luo" },
    { code: "lb", name: "Luxembourgish" },
    { code: "mk", name: "Macedonian" },
    { code: "mad", name: "Madurese" },
    { code: "mai", name: "Maithili" },
    { code: "mak", name: "Makassar" },
    { code: "mg", name: "Malagasy" },
    { code: "ms", name: "Malay" },
    { code: "ms-Arab", name: "Malay (Jawi)" },
    { code: "ml", name: "Malayalam" },
    { code: "mt", name: "Maltese" },
    { code: "mam", name: "Mam" },
    { code: "gv", name: "Manx" },
    { code: "mi", name: "Maori" },
    { code: "mr", name: "Marathi" },
    { code: "mh", name: "Marshallese" },
    { code: "mwr", name: "Marwadi" },
    { code: "mfe", name: "Mauritian Creole" },
    { code: "chm", name: "Meadow Mari" },
    { code: "mni-Mtei", name: "Meiteilon (Manipuri)" },
    { code: "min", name: "Minang" },
    { code: "lus", name: "Mizo" },
    { code: "mn", name: "Mongolian" },
    { code: "my", name: "Myanmar (Burmese)" },
    { code: "bm-Nkoo", name: "N'Ko" },
    { code: "nhe", name: "Nahuatl (Eastern Huasteca)" },
    { code: "ndc-ZW", name: "Ndau" },
    { code: "nr", name: "Ndebele (South)" },
    { code: "new", name: "Nepal Bhasa (Newari)" },
    { code: "ne", name: "Nepali" },
    { code: "no", name: "Norwegian" },
    { code: "nus", name: "Nuer" },
    { code: "oc", name: "Occitan" },
    { code: "or", name: "Odia (Oriya)" },
    { code: "om", name: "Oromo" },
    { code: "os", name: "Ossetian" },
    { code: "pag", name: "Pangasinan" },
    { code: "pap", name: "Papiamento" },
    { code: "ps", name: "Pashto" },
    { code: "fa", name: "Persian" },
    { code: "pl", name: "Polish" },
    { code: "pt", name: "Portuguese (Brazil)" },
    { code: "pt-PT", name: "Portuguese (Portugal)" },
    { code: "pa", name: "Punjabi (Gurmukhi)" },
    { code: "pa-Arab", name: "Punjabi (Shahmukhi)" },
    { code: "qu", name: "Quechua" },
    { code: "kek", name: "Qʼeqchiʼ" },
    { code: "rom", name: "Romani" },
    { code: "ro", name: "Romanian" },
    { code: "rn", name: "Rundi" },
    { code: "ru", name: "Russian" },
    { code: "se", name: "Sami (North)" },
    { code: "sm", name: "Samoan" },
    { code: "sg", name: "Sango" },
    { code: "sa", name: "Sanskrit" },
    { code: "sat-Latn", name: "Santali (Latin)" },
    { code: "sat", name: "Santali (Ol Chiki)" },
    { code: "gd", name: "Scots Gaelic" },
    { code: "nso", name: "Sepedi" },
    { code: "sr", name: "Serbian" },
    { code: "st", name: "Sesotho" },
    { code: "crs", name: "Seychellois Creole" },
    { code: "shn", name: "Shan" },
    { code: "sn", name: "Shona" },
    { code: "scn", name: "Sicilian" },
    { code: "szl", name: "Silesian" },
    { code: "sd", name: "Sindhi" },
    { code: "si", name: "Sinhala" },
    { code: "sk", name: "Slovak" },
    { code: "sl", name: "Slovenian" },
    { code: "so", name: "Somali" },
    { code: "es", name: "Spanish" },
    { code: "su", name: "Sundanese" },
    { code: "sus", name: "Susu" },
    { code: "sw", name: "Swahili" },
    { code: "ss", name: "Swati" },
    { code: "sv", name: "Swedish" },
    { code: "ty", name: "Tahitian" },
    { code: "tg", name: "Tajik" },
    { code: "ber-Latn", name: "Tamazight" },
    { code: "ber", name: "Tamazight (Tifinagh)" },
    { code: "ta", name: "Tamil" },
    { code: "tt", name: "Tatar" },
    { code: "te", name: "Telugu" },
    { code: "tet", name: "Tetum" },
    { code: "th", name: "Thai" },
    { code: "bo", name: "Tibetan" },
    { code: "ti", name: "Tigrinya" },
    { code: "tiv", name: "Tiv" },
    { code: "tpi", name: "Tok Pisin" },
    { code: "to", name: "Tongan" },
    { code: "lua", name: "Tshiluba" },
    { code: "ts", name: "Tsonga" },
    { code: "tn", name: "Tswana" },
    { code: "tcy", name: "Tulu" },
    { code: "tum", name: "Tumbuka" },
    { code: "tr", name: "Turkish" },
    { code: "tk", name: "Turkmen" },
    { code: "tyv", name: "Tuvan" },
    { code: "ak", name: "Twi" },
    { code: "udm", name: "Udmurt" },
    { code: "uk", name: "Ukrainian" },
    { code: "ur", name: "Urdu" },
    { code: "ug", name: "Uyghur" },
    { code: "uz", name: "Uzbek" },
    { code: "ve", name: "Venda" },
    { code: "vec", name: "Venetian" },
    { code: "vi", name: "Vietnamese" },
    { code: "war", name: "Waray" },
    { code: "cy", name: "Welsh" },
    { code: "wo", name: "Wolof" },
    { code: "xh", name: "Xhosa" },
    { code: "sah", name: "Yakut" },
    { code: "yi", name: "Yiddish" },
    { code: "yo", name: "Yoruba" },
    { code: "yua", name: "Yucatec Maya" },
    { code: "zap", name: "Zapotec" },
    { code: "zu", name: "Zulu" },
  ];

  // Paginated view of languages in modal (show first 20, then load more on scroll)
  visibleLanguageOptions: { code: string; name: string }[] = [];
  private languagePageSize: number = 20;
  private languageLoadedCount: number = 0;
  languageSearchTerm: string = "";

  // App layout properties
  sidebarCollapsed: boolean = false;
  searchInput: string = "";
  showMobileSearch: boolean = false;
  private searchInputSubject: Subject<string> = new Subject<string>();

  // Header Items-search (multi-item chips)
  currentSearchCategory: string = "All"; // query param category (All/Users/Bundles/Items)
  selectedItemSearchChips: string[] = [];
  itemSearchSuggestions: ItemLibraryModel[] = [];
  private itemSearchInput$ = new Subject<string>();
  userMentionSuggestions: any[] = [];
  private userMentionInput$ = new Subject<string>();
  // Chip input separators for Items mode (comma only; Enter is handled by globalSearch()).
  readonly itemChipSeparatorKeys: number[] = [COMMA];

  get isItemsSearchMode(): boolean {
    return (this.currentSearchCategory || "").toLowerCase() === "items";
  }

  /** Home / search view is the empty route. */
  get isSearchPageRoute(): boolean {
    const path = (this.router.url || "")
      .split("?")[0]
      .replace(/\/$/, "");
    return path === "" || path === "/";
  }

  /** Auth pages that also open as the overlay — hide the routed duplicate behind the modal. */
  get isAuthPageRoute(): boolean {
    const path = (this.router.url || "").split("?")[0];
    return (
      path === "/login" ||
      path.startsWith("/login/") ||
      path === "/registration" ||
      path.startsWith("/registration/") ||
      path === "/activateaccount" ||
      path.startsWith("/activateaccount/") ||
      path.includes("/forget-password") ||
      path.includes("/forgot-password") ||
      (path.includes("/change-password") && !path.includes("/user-settings/"))
    );
  }

  /**
   * With multiple Items search terms, chips are shown above the category bar
   * on the search page instead of inside the header.
   */
  get showItemChipsInHeader(): boolean {
    if (!this.isItemsSearchMode) {
      return false;
    }
    const n = this.selectedItemSearchChips.length;
    if (n === 0) {
      return false;
    }
    if (this.isSearchPageRoute && n > 0) {
      return false;
    }
    return true;
  }

  
  // ── Category / search-field selector (Pexels-style left-side pill) ────────────
  showCategoryDropdown: boolean = false;

  /**
   * Current search-field filter used when the Flows tab is active.
   * 'All'        → search across all flow properties (default)
   * 'Title'      → filter by flow title
   * 'UniqueCode' → filter by unique code
   * 'Items'      → switches to Items chip-search mode
   */
  flowSearchField: 'All' | 'Title' | 'UniqueCode' | 'Items' = 'All';

  /**
   * Explicit flag for the Flows-only search-field pill (Flow / Title / Unique Code / Items).
   * Kept as a property (not only a getter) so iOS Safari reliably updates *ngIf after tab changes.
   */
  categorySelectorVisible: boolean = true;

  /**
   * Show the selector pill on the Flows tab and on the Items tab so the user
   * can always switch back to Flow / Title / UniqueCode from Items mode.
   */
  get showCategorySelector(): boolean {
    return this.categorySelectorVisible;
  }

  /** Sync Flow-only selector visibility when search tab changes (Flows / Users / Bundles / Items). */
  private syncCategorySelectorFromCategory(category: string): void {
    const cat = (category || 'All').toString();
    this.categorySelectorVisible =
      cat === 'All' || cat.toLowerCase() === 'items';
    if (!this.categorySelectorVisible) {
      this.showCategoryDropdown = false;
    }
    // iOS/Safari often skips a CD pass after query-param-only navigations.
    this.cdr.detectChanges();
    if (typeof requestAnimationFrame === 'function') {
      requestAnimationFrame(() => this.cdr.detectChanges());
    }
  }

  /** Label shown inside the pill button. */
  get searchCategoryLabel(): string {
    switch (this.flowSearchField) {
      case 'Title':      return 'Title';
      case 'UniqueCode': return 'Unique Code';
      case 'Items':      return 'Items';
      default:           return FrontlineGlossary.singular;
    }
  }

  /** Material icon for the mobile icon-only pill. */
  get searchCategoryIcon(): string {
    switch (this.flowSearchField) {
      case 'Title':      return 'title';
      case 'UniqueCode': return 'tag';
      case 'Items':      return 'inventory_2';
      default:           return 'account_tree';
    }
  }

  /** Bundles uses a PNG instead of mat-icon — never shown in selector now, kept for safety. */
  get isBundleCategory(): boolean {
    return this.activeHomeCategory === 'Bundles';
  }

  toggleCategoryDropdown(event: Event): void {
    event.stopPropagation();
    this.showCategoryDropdown = !this.showCategoryDropdown;
    if (this.showCategoryDropdown) {
      this.showSearchHistory = false;
    }
  }

  /**
   * Called when user picks a search-field option inside the Flows dropdown.
   * Selecting 'Items' navigates to the Items category (chip-search mode).
   */
  selectFlowSearchField(field: string, event?: Event): void {
    if (event) { event.stopPropagation(); }
    this.showCategoryDropdown = false;
    if (field === 'Items') {
      this.navigateToItems();
      return;
    }
    this.flowSearchField = field as 'All' | 'Title' | 'UniqueCode';
    this.router.navigate(['/'], {
      queryParams: {
        category: 'All',
        searchField: field !== 'All' ? field : null,
      },
      queryParamsHandling: 'merge',
      replaceUrl: true,
    });
  }

  /** Legacy — kept so sidebar and other callers still compile. */
  selectSearchCategory(category: string, event?: Event): void {
    if (event) { event.stopPropagation(); }
    this.showCategoryDropdown = false;
    switch (category) {
      case 'Flows':   this.navigateToFlows();   break;
      case 'Users':   this.navigateToUsers();   break;
      case 'Bundles': this.navigateToBundles(); break;
      case 'Items':   this.navigateToItems();   break;
    }
  }

  // Search History properties
  showSearchHistory: boolean = false;
  searchHistory: string[] = [];
  filteredSearchHistory: string[] = [];
  selectedHistoryIndex: number = -1;
  @ViewChild('searchInputElement', { static: false }) searchInputElement: ElementRef<HTMLInputElement>;
  @ViewChild('mobileSearchInputElement', { static: false }) mobileSearchInputElement: ElementRef<HTMLInputElement>;
  
  // Auth Modal properties
  currentModal: AuthModalType = null;
  get showMenu(): boolean {
    const url = this.route.url || "";
    return !(url.startsWith("/login") || 
             url.startsWith("/registration") || 
             url.startsWith("/aboutus") || 
             url.startsWith("/how-it-works") ||
             url.startsWith("/faq") ||
             url.startsWith("/privacy") ||
             url.startsWith("/privacypolicy") ||
             url.startsWith("/tandc") ||
             url.startsWith("/termsandconditions") ||
             url.startsWith("/community-guidelines") ||
             url.startsWith("/cookie-policy") ||
             url.startsWith("/law-enforcement") ||
             url.startsWith("/embed/"));
  }

  get showSidebar(): boolean {
    const url = this.route.url || "";
    // Sidebar should be visible on all pages except login/registration
    // Even on about-us and how-it-works pages where main header is hidden
    return !(url.startsWith("/login") || url.startsWith("/registration") || url.startsWith("/embed/"));
  }
  get isFullWidthRoute(): boolean {
    const url = this.route.url || "";
    return (
      url.startsWith("/adminctrl") ||
      url.startsWith("/user-dashboard") ||
      url.startsWith("/user-settings") ||
      url.startsWith("/user-profile") ||
      url.startsWith("/view-profile")
    );
  }

  get isOnUserProfilePage(): boolean {
    const url = (this.route.url || "").split("?")[0].replace(/\/$/, "") || "";
    return url === "/user-profile" || url.startsWith("/user-profile/");
  }

  trialStripDismissed = false;
  readonly paypalAutopayUrl = PAYPAL_AUTOPAY_URL;

  /**
   * Which account strip to show at the top of the page (not on checkout, embeds or auth pages):
   * a failed payment that ended the subscription, a failed charge PayPal is retrying,
   * a finished trial waiting for its first payment, or the running trial.
   */
  get accountStripMode(): "payment-failed" | "payment-issue" | "payment-pending" | "trial" | null {
    if (!this.isUserLoggedIn) return null;
    const url = (this.route.url || "").split("?")[0];
    if (
      url.startsWith("/subscriptions") ||
      url.startsWith("/embed/") ||
      url.startsWith("/login") ||
      url.startsWith("/registration")
    ) {
      return null;
    }

    if (getUndismissedPaymentFailure()) return "payment-failed";
    if (!isTrialActive()) return null;
    const state = this.trialStateService.snapshot;
    if (state?.paymentIssue) return "payment-issue";
    if (state?.paymentPending) return "payment-pending";
    return this.trialStripDismissed ? null : "trial";
  }

  get paymentFailedPlanName(): string {
    const plan = (this.trialStateService.snapshot?.lastPaymentFailedPlanId || "starter").toLowerCase();
    return plan.charAt(0).toUpperCase() + plan.slice(1);
  }

  dismissPaymentFailedStrip(): void {
    dismissPaymentFailure();
  }

  openResubscribe(): void {
    const plan = (this.trialStateService.snapshot?.lastPaymentFailedPlanId || "starter").toLowerCase();
    void this.router.navigate(["/subscriptions"], {
      queryParams: { plan: plan === "growth" ? "growth" : "starter", billing: "monthly" },
    });
  }

  get trialDaysLeftLabel(): string {
    const days = this.trialStateService.snapshot?.daysLeft ?? 0;
    return days === 1 ? "1 day" : `${days} days`;
  }

  openTrialUpgrade(): void {
    void this.router.navigate(["/pricing"], { queryParams: { trial: "reminder" } });
  }

  openTrialManage(): void {
    void this.router.navigate(["/subscriptions"], {
      queryParams: { plan: "starter", billing: "annual", manage: "trial" },
    });
  }

  constructor(
    private activateRouter: ActivatedRoute,
    private flowServiceService: FlowServiceService,
    private dataService: DataService,
    private router: Router,
    private userserviceService: UserserviceService,
    //
    private data: DataService,
    public route: Router,
    private toastr: ToastrService,
    // private translateService: TranslateService,
    private eventEmitterService: EventEmitterService,
    private searchHistoryService: SearchHistoryService,
    private location: Location,
    public dialog: MatDialog,
    private authService: AuthService,
    private tokenService: TokenService,
    private cdr: ChangeDetectorRef,
    private authModalService: AuthModalService,
    private translationService: TranslationService,
    private itemLibraryService: ItemLibraryService,
    private themePreferenceService: ThemePreferenceService,
    private permissionsService: PermissionsService,
    private subscriptionUsageAlertService: SubscriptionUsageAlertService,
    private orgContextService: OrgContextService,
    private orgNotificationService: OrgNotificationService,
    public trialStateService: TrialStateService
  ) {
    // Initialize sidebar state based on screen size - closed by default on mobile
    if (typeof window !== "undefined") {
      const width = window.innerWidth || document.body.clientWidth;
      const isMobile = width <= 955;
      this.sidebarCollapsed = isMobile; // Closed by default on mobile
      this.isMobileView = isMobile;
    }

    this.turnOnNightMode = "Turn On Night Mode";
    this.initializeThemeMode();
    this.themePreferenceService.themeChanges$.subscribe((theme) =>
      this.applyThemeMode(theme)
    );
    this.infiniteScrollCount = 5;
    this.getNotificationUrl = "v1/Notification/GetUserNotifications";
    // this.translateService.addLangs(["en", "tr"]);
    // this.translateService.setDefaultLang("en");
    // this.translateService.use("en");
    this.premissionToActions = JSON.parse(
      localStorage.getItem("PremissionToActions")
    );
    if (this.eventEmitterService.loginCompleted === undefined) {
      this.eventEmitterService.loginCompleted =
        this.eventEmitterService.invokeComponentFunction.subscribe(
          (name: string) => {
            this.getProfileUser();
          }
        );
    }

    if (
      this.eventEmitterService.setHomePageIconColorFunctionCompleted ===
      undefined
    ) {
      this.eventEmitterService.setHomePageIconColorFunctionCompleted =
        this.eventEmitterService.setHomePageIconColorFunction.subscribe(
          (name: string) => {
            this.setPageColor(name);
          }
        );
    }

    if (
      this.eventEmitterService.setUserProfileCreateIconClickedEventCompleted ===
      undefined
    ) {
      this.eventEmitterService.setUserProfileCreateIconClickedEventCompleted =
        this.eventEmitterService.setUserProfileCreateIconClickedFunction.subscribe(
          (name: string) => {
            this.iconClicked(name);
          }
        );
    }
    this.eventEmitterService.setHomePageDashboardProperty.subscribe(
      (name: boolean) => {
        this.isuserdashboard = name;
      }
    );
    this.eventEmitterService.setLoggedInUserDataProperty.subscribe(
      (name: boolean) => {
        this.isUserLoggedIn = name;
        if (!name) {
          this.userDisplayName = null;
        } else {
          // When user logs in, read user data from localStorage and update display name
          const userData = JSON.parse(localStorage.getItem("LoggedInUser"));
          if (userData != null) {
            this.userDisplayName = userData.firstName;
            this.userDisplayEmail = userData.emailAddress;
            this.userData = userData;
            this.applyProfilePictureFromStoredUser();
            // Load full profile data and notifications (notifications are
            // fetched once the account type resolves, if not already loaded).
            this.getProfileUser();
            this.notificationsScopeKey = null;
            this.getnotification();
            this.refreshPermissionsFromServer(userData);
            this.cdr.detectChanges();
          }
        }
      }
    );

    this.permissionsService.permissionsUpdated$.subscribe(() => {
      this.checkPermissions();
      this.cdr.markForCheck();
    });

    const navEndEvents = this.router.events.pipe(
      filter((event) => event instanceof NavigationEnd)
    );

    navEndEvents.subscribe((event: NavigationEnd) => {
      gtag("config", "G-3MY3PGF39Q", {
        "page-path": event.urlAfterRedirects,
      });
    });

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        gtag("config", "GTM-T7JVMSK", {
          page_path: event.urlAfterRedirects,
        });
        
        // Handle auth modal routes — open modal, then clear the page route so the
        // same form is not also rendered in <router-outlet> behind the overlay.
        const url = event.urlAfterRedirects;
        if (url === '/login' || url.startsWith('/login')) {
          this.openAuthModalFromRoute('login');
        } else if (url === '/registration' || url.startsWith('/registration')) {
          this.openAuthModalFromRoute('registration');
        } else if (url === '/activateaccount' || url.startsWith('/activateaccount')) {
          this.openAuthModalFromRoute('activateaccount');
        } else if ((url.includes('/forget-password') || url.includes('/forgot-password')) && !url.includes('/user-settings/forget-password')) {
          this.openAuthModalFromRoute('forget-password');
        } else if (url.includes('/change-password') && !url.includes('/user-settings/')) {
          this.openAuthModalFromRoute('change-password');
        } else if (url.includes('/user-settings/forget-password')) {
          // Close modal if navigating to user-settings forget password page
          this.authModalService.closeModal();
        } else if (!this.authModalService.consumePreserveOnNextNavigation()) {
          this.authModalService.closeModal();
        }
      }
    });
    
    // Subscribe to modal state changes
    this.authModalService.modalState$.subscribe((modalType) => {
      this.currentModal = modalType;
    });

    // After dynamic content is re-translated, hide Google iframes again on desktop
    this.translationService.afterRetranslate$.subscribe(() => {
      this.hideDesktopTranslateIframes();
    });

    // subscribe to router events and send page views to Google Analytics
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        ga("set", "page", event.urlAfterRedirects);
        ga("send", "pageview");

        // Close sidebar when navigating to view flow page (guide routes)
        const url = event.urlAfterRedirects;
        if (
          url.startsWith("/guide/") ||
          url.startsWith("/perform/") ||
          url === "/view" ||
          url.startsWith("/view-guide-pack") ||
          url.startsWith("/create-guide") ||
          url.startsWith("/create-guide-pack") ||
          url.startsWith("/collaboration-requests")
        ) {
          this.sidebarCollapsed = true;
        }

        // Refresh notification count when navigating away from notifications page
        if (this.userData && !url.startsWith("/notifications")) {
          // Update count to show only unread notifications
          this.notificationscount = this.notificationsarray.filter(
            (notification) => !notification.notification.NotificationSeen
          ).length;

          if (this.notificationscount > 0) {
            this.showNotificationCount = true;
          } else {
            this.showNotificationCount = false;
          }
        }

        // Ensure profile icon highlight state is updated when route changes
        this.cdr.markForCheck();
        this.scheduleTranslateUiSync();
      }
    });
  }
  async ngAfterViewInit(): Promise<void> {
    if (this.userData) {
      await this.checkPermissions();
    }
    // Listen for toggleSidebar events from child components
    if (typeof window !== 'undefined') {
      window.addEventListener('toggleSidebar', () => {
        this.toggleSidebar();
      });
    }
    // Initialize Google Translate in header for desktop
    this.initializeGoogleTranslate();
    // Fix mobile translate positioning
    this.fixMobileTranslatePosition();
    // Watch for translate banner changes on mobile
    this.watchTranslateBanner();
    // Ensure translate widgets stay visible
    this.ensureTranslateVisibility();
    // Adjust chatbot position for translate banner on mobile
    if (this.isMobileView) {
      setTimeout(() => this.adjustChatbotPositionForTranslate(), 500);
    }
    
    // On desktop, hide footer translate (show in header instead)
    if (!this.isMobileView) {
      setTimeout(() => {
        this.moveTranslateIframeToFooter();
      }, 100);
    }

    this.scheduleTranslateUiSync();
  }

  private trackPerformanceInterval(fn: () => void, ms: number): ReturnType<typeof setInterval> {
    const id = setInterval(fn, ms);
    this.performanceIntervals.push(id);
    return id;
  }

  private trackPerformanceObserver(observer: MutationObserver): void {
    this.performanceObservers.push(observer);
  }

  private clearPerformanceTimers(): void {
    this.performanceIntervals.forEach((id) => clearInterval(id));
    this.performanceIntervals = [];
    this.performanceObservers.forEach((observer) => observer.disconnect());
    this.performanceObservers = [];
    if (this.translateUiSyncTimeout) {
      clearTimeout(this.translateUiSyncTimeout);
      this.translateUiSyncTimeout = null;
    }
    if (this.translateBannerSyncTimeout) {
      clearTimeout(this.translateBannerSyncTimeout);
      this.translateBannerSyncTimeout = null;
    }
    if ((window as any).__mobileTranslateMonitor) {
      clearInterval((window as any).__mobileTranslateMonitor);
      (window as any).__mobileTranslateMonitor = null;
    }
  }

  /** Throttled translate UI sync — same work as before, not on every change-detection cycle. */
  private scheduleTranslateUiSync(): void {
    if (this.translateUiSyncTimeout) {
      return;
    }
    this.translateUiSyncTimeout = setTimeout(() => {
      this.translateUiSyncTimeout = null;
      this.syncTranslateUi();
    }, 250);
  }

  private syncTranslateUi(): void {
    if (!this.isMobileView) {
      const headerElement = document.getElementById(
        "google_translate_element_header"
      );
      if (headerElement) {
        headerElement.style.display = "block";
        headerElement.style.visibility = "visible";
        headerElement.style.opacity = "1";
      }

      if (!this.googleTranslateInitialized) {
        this.initializeGoogleTranslate();
      }

      this.setupDesktopTranslateToggle();
      this.updateDesktopTranslateToggle();

      if (
        !(window as any).__lastTranslateReposition ||
        Date.now() - (window as any).__lastTranslateReposition > 2000
      ) {
        this.moveTranslateIframeToFooter();
        (window as any).__lastTranslateReposition = Date.now();
      }
    } else {
      this.fixMobileTranslatePosition();
      this.adjustChatbotPositionForTranslate();
    }
  }

  private scheduleTranslateBannerSync(): void {
    if (this.translateBannerSyncTimeout) {
      return;
    }
    this.translateBannerSyncTimeout = setTimeout(() => {
      this.translateBannerSyncTimeout = null;
      if (this.isMobileView) {
        this.adjustContentForTranslateBanner();
        this.moveBannerToFooter();
        this.moveTranslateIframeToFooter();
        this.adjustChatbotPositionForTranslate();
      } else {
        this.updateDesktopTranslateToggle();
      }
    }, 350);
  }

  ngOnDestroy(): void {
    this.clearPerformanceTimers();
    this.orgContextWatchSub?.unsubscribe();
    this.orgContextWatchSub = null;
  }

  ensureTranslateVisibility(): void {
    // Keep visibility checks, but at a lower frequency to reduce idle CPU use.
    this.trackPerformanceInterval(() => {
      if (!this.isMobileView) {
        const headerElement = document.getElementById(
          "google_translate_element_header"
        );
        if (headerElement) {
          headerElement.style.display = "block";
          headerElement.style.visibility = "visible";
          headerElement.style.opacity = "1";

          const allChildren = headerElement.querySelectorAll("*");
          allChildren.forEach((el: any) => {
            if (el?.style?.display === "none") {
              el.style.display = "";
            }
            if (el?.style?.visibility === "hidden") {
              el.style.visibility = "visible";
            }
          });
        }
      } else {
        const mobileTranslateBtn = document.querySelector(
          ".mobile-translate-floating-btn"
        );
        if (mobileTranslateBtn) {
          (mobileTranslateBtn as HTMLElement).style.display = "flex";
          (mobileTranslateBtn as HTMLElement).style.visibility = "visible";
          (mobileTranslateBtn as HTMLElement).style.opacity = "1";
        }
      }
    }, 8000);
  }

  watchTranslateBanner(): void {
    if (typeof MutationObserver !== "undefined" && document.body) {
      const observer = new MutationObserver(() => {
        this.scheduleTranslateBannerSync();
      });
      observer.observe(document.body, {
        childList: true,
        subtree: true,
      });
      this.trackPerformanceObserver(observer);
    }

    // Fallback poll — slower than before, still catches late-injected translate widgets.
    this.trackPerformanceInterval(() => {
      this.scheduleTranslateBannerSync();
    }, 3000);
  }

  adjustChatbotPositionForTranslate(): void {
    if (!this.isMobileView) {
      return;
    }

    const translateBanner = document.querySelector('.goog-te-banner-frame') as HTMLElement;
    const translateIframe = document.querySelector('iframe.VIpgJd-ZVi9od-ORHb-OEVmcd') as HTMLElement;
    const chatbotFooter = document.querySelector('.chatbot-stickyfooter') as HTMLElement;
    const chatbotWrapper = document.querySelector('.chatbot-wrapper') as HTMLElement;

    // Check if translate banner/iframe is visible
    const isTranslateVisible = 
      (translateBanner && 
       translateBanner.style.display !== 'none' && 
       translateBanner.style.visibility !== 'hidden' &&
       !translateBanner.classList.contains('translate-collapsed')) ||
      (translateIframe && 
       translateIframe.style.display !== 'none' && 
       translateIframe.style.visibility !== 'hidden' &&
       !translateIframe.classList.contains('translate-collapsed'));

    if (isTranslateVisible) {
      // Get the actual height of the translate banner
      const translateHeight = translateBanner ? 
        Math.max(translateBanner.offsetHeight, 60) : 
        (translateIframe ? Math.max(translateIframe.offsetHeight, 60) : 60);
      
      // Position chatbot above translate banner
      if (chatbotFooter) {
        chatbotFooter.style.bottom = `${translateHeight}px`;
        chatbotFooter.style.zIndex = '1002';
        chatbotFooter.style.position = 'fixed';
      }
      
      if (chatbotWrapper) {
        chatbotWrapper.style.bottom = `${translateHeight}px`;
        chatbotWrapper.style.zIndex = '1002';
      }
    } else {
      // Reset chatbot position when translate is hidden
      if (chatbotFooter) {
        chatbotFooter.style.bottom = '0';
        chatbotFooter.style.zIndex = '1002';
        chatbotFooter.style.position = 'fixed';
      }
      
      if (chatbotWrapper) {
        chatbotWrapper.style.bottom = '0';
        chatbotWrapper.style.zIndex = '1002';
      }
    }
  }

  updateDesktopTranslateToggle(): void {
    if (this.isMobileView) {
      return;
    }

    const translateIframe = document.querySelector('iframe.VIpgJd-ZVi9od-ORHb-OEVmcd') as HTMLElement;
    const bannerFrame = document.querySelector('.goog-te-banner-frame') as HTMLElement;
    const toggleButton = document.querySelector('.translate-banner-toggle') as HTMLElement;

    // Check if translate banner/iframe is visible (not collapsed)
    const isVisible = 
      (translateIframe && 
       translateIframe.style.display !== 'none' && 
       !translateIframe.classList.contains('translate-collapsed') &&
       translateIframe.style.visibility !== 'hidden') ||
      (bannerFrame && 
       bannerFrame.style.display !== 'none' && 
       !bannerFrame.classList.contains('translate-collapsed') &&
       bannerFrame.style.visibility !== 'hidden');

    if (toggleButton) {
      if (isVisible) {
        toggleButton.style.display = 'flex';
        // Update collapsed state based on actual state
        const isCollapsed = 
          (translateIframe && translateIframe.classList.contains('translate-collapsed')) ||
          (bannerFrame && bannerFrame.classList.contains('translate-collapsed'));
        this.isTranslateBannerCollapsed = isCollapsed;
      } else {
        // Hide toggle button if banner is not visible at all
        toggleButton.style.display = 'none';
      }
    }
  }

  moveBannerToFooter(): void {
    // Only move to footer on mobile, hide on desktop (show in header instead)
    if (this.isMobileView) {
      // Move banner frame to footer
      const bannerFrame = document.querySelector(
        ".goog-te-banner-frame"
      ) as HTMLElement;
      if (bannerFrame) {
        // Position banner at footer with constrained height - at very bottom
        bannerFrame.style.position = "fixed";
        bannerFrame.style.bottom = "0";
        bannerFrame.style.top = "auto";
        bannerFrame.style.left = "0";
        bannerFrame.style.right = "0";
        bannerFrame.style.marginBottom = "0"; // No margin - at very bottom like old menu footer
        bannerFrame.style.zIndex = "1001";
        bannerFrame.style.width = "100%";
        bannerFrame.style.maxWidth = "100%";
        bannerFrame.style.maxHeight = `calc(100vh - 90px)`; // Footer height
        bannerFrame.style.overflowY = "auto"; // Enable scrolling
        bannerFrame.style.overflowX = "hidden";
        const isDark = document.body.classList.contains("theme-dark");
        bannerFrame.style.backgroundColor = isDark ? "#1f2937" : "#ffffff";
        bannerFrame.style.borderTop = isDark ? "1px solid rgba(148,163,184,0.25)" : "1px solid #e0e0e0";
        bannerFrame.style.boxShadow = "0 -2px 10px rgba(0, 0, 0, 0.1)";

        // Style the banner content
        const bannerContent = bannerFrame.querySelector("skipptr") as HTMLElement;
        if (bannerContent) {
          bannerContent.style.backgroundColor = isDark ? "#1f2937" : "#ffffff";
          bannerContent.style.borderTop = isDark ? "1px solid rgba(148,163,184,0.25)" : "1px solid #e0e0e0";
          bannerContent.style.boxShadow = "0 -2px 10px rgba(0, 0, 0, 0.1)";
          bannerContent.style.padding = "12px 16px";
          bannerContent.style.paddingBottom = `max(12px, env(safe-area-inset-bottom))`;
          bannerContent.style.maxHeight = `calc(100vh - 90px)`;
          bannerContent.style.overflowY = "auto";
          bannerContent.style.overflowX = "hidden";
        }
      }
    } else {
      // On desktop, position banner frame at bottom right
      const bannerFrame = document.querySelector(
        ".goog-te-banner-frame"
      ) as HTMLElement;
      if (bannerFrame) {
        bannerFrame.style.position = "fixed";
        bannerFrame.style.bottom = "0";
        bannerFrame.style.top = "auto";
        bannerFrame.style.left = "auto";
        bannerFrame.style.right = "0";
        bannerFrame.style.width = "auto";
        bannerFrame.style.maxWidth = "400px";
        bannerFrame.style.minHeight = "60px";
        bannerFrame.style.maxHeight = "300px";
        bannerFrame.style.zIndex = "1001";
        bannerFrame.style.display = "block";
        bannerFrame.style.visibility = "visible";
        bannerFrame.style.opacity = "1";
        const isDarkDesktop = document.body.classList.contains("theme-dark");
        bannerFrame.style.backgroundColor = isDarkDesktop ? "#1f2937" : "#ffffff";
        bannerFrame.style.borderTop = isDarkDesktop ? "1px solid rgba(148,163,184,0.25)" : "1px solid #e0e0e0";
        bannerFrame.style.borderLeft = isDarkDesktop ? "1px solid rgba(148,163,184,0.25)" : "1px solid #e0e0e0";
        bannerFrame.style.boxShadow = "0 -2px 10px rgba(0, 0, 0, 0.1)";
        
        // Style the banner content - align to right
        const bannerContent = bannerFrame.querySelector("skipptr") as HTMLElement;
        if (bannerContent) {
          bannerContent.style.display = "flex";
          bannerContent.style.justifyContent = "flex-end";
          bannerContent.style.alignItems = "center";
          bannerContent.style.textAlign = "right";
          bannerContent.style.padding = "16px";
          bannerContent.style.paddingBottom = `max(16px, env(safe-area-inset-bottom))`;
        }
      }
    }
  }

  moveTranslateIframeToFooter(): void {
    // Only move to footer on mobile, hide on desktop (show in header instead)
    if (this.isMobileView) {
      // Move Google Translate iframe to footer - multiple selectors to catch all variations
      const translateIframes = document.querySelectorAll(
        'iframe.skiptranslate, iframe[class*="skiptranslate"], iframe.VIpgJd-ZVi9od-ORHb-OEVmcd, iframe[id*="container"]'
      ) as NodeListOf<HTMLElement>;

      translateIframes.forEach((iframe) => {
        if (iframe) {
          // Check if it's a Google Translate iframe by checking class or id
          const isTranslateIframe =
            iframe.classList.contains("skiptranslate") ||
            iframe.className.includes("skiptranslate") ||
            iframe.className.includes("VIpgJd-ZVi9od") ||
            iframe.id.includes("container");

          if (isTranslateIframe) {
            // Position iframe at footer with constrained height - at very bottom
            // Use setProperty with important flag to override Google Translate's inline styles
            iframe.style.setProperty("position", "fixed", "important");
            iframe.style.setProperty("bottom", "0", "important");
            iframe.style.setProperty("top", "auto", "important");
            iframe.style.setProperty("left", "0", "important");
            iframe.style.setProperty("right", "0", "important");
            iframe.style.setProperty("margin", "0", "important");
            iframe.style.setProperty("margin-top", "0", "important");
            iframe.style.setProperty("margin-bottom", "0", "important");
            iframe.style.setProperty("z-index", "1001", "important");
            iframe.style.setProperty("width", "100%", "important");
            iframe.style.setProperty("max-width", "100%", "important");
            iframe.style.setProperty("max-height", `calc(100vh - 90px)`, "important");
            iframe.style.setProperty("visibility", "visible", "important");
            iframe.style.setProperty("overflow-y", "auto", "important");
            iframe.style.setProperty("overflow-x", "hidden", "important");
            const isDarkIframe = document.body.classList.contains("theme-dark");
            iframe.style.setProperty("background-color", isDarkIframe ? "#1f2937" : "#ffffff", "important");
            iframe.style.setProperty("border-top", isDarkIframe ? "1px solid rgba(148,163,184,0.25)" : "1px solid #e0e0e0", "important");
            iframe.style.setProperty("box-shadow", "0 -2px 10px rgba(0, 0, 0, 0.1)", "important");
            iframe.style.setProperty("transform", "none", "important");
          }
        }
      });
    } else {
      // On desktop, hide all Google Translate iframes (we use custom modal only)
      this.hideDesktopTranslateIframes();
    }
  }

  /** Force-hide all Google Translate iframes via inline style (overrides Google’s !important). */
  hideDesktopTranslateIframes(): void {
    const selectors = [
      'iframe.skiptranslate',
      'iframe[class*="VIpgJd"]',
      'iframe[class*="OEVmcd"]',
      'iframe[title*="traducción"]',
      'iframe[title*="traduction"]',
      'iframe[title*="Translate"]',
      'iframe[title*="translation"]',
    ];
    const seen = new Set<Element>();
    selectors.forEach((sel) => {
      try {
        document.querySelectorAll(sel).forEach((el) => {
          if (el && !seen.has(el)) {
            seen.add(el);
            const iframe = el as HTMLElement;
            iframe.style.setProperty('display', 'none', 'important');
            iframe.style.setProperty('visibility', 'hidden', 'important');
            iframe.style.setProperty('opacity', '0', 'important');
            iframe.style.setProperty('width', '0', 'important');
            iframe.style.setProperty('height', '0', 'important');
            iframe.style.setProperty('max-width', '0', 'important');
            iframe.style.setProperty('min-height', '0', 'important');
            iframe.style.setProperty('max-height', '0', 'important');
            iframe.style.setProperty('pointer-events', 'none', 'important');
            iframe.style.setProperty('position', 'absolute', 'important');
            iframe.style.setProperty('left', '-9999px', 'important');
            iframe.style.setProperty('z-index', '-9999', 'important');
          }
        });
      } catch (_) {}
    });
  }

  private syncTranslateUiOnResize(): void {
    this.scheduleTranslateUiSync();
    this.scheduleTranslateBannerSync();
  }
  
  setupDesktopTranslateToggle(): void {
    if (this.isMobileView) {
      return;
    }
    
    // Check if toggle button already exists
    let toggleButton = document.querySelector('.translate-toggle-button') as HTMLElement;
    
    if (!toggleButton) {
      // Create toggle button
      toggleButton = document.createElement('button');
      toggleButton.className = 'translate-toggle-button';
      toggleButton.setAttribute('aria-label', 'Toggle translate section');
      toggleButton.setAttribute('title', 'Show/Hide translate');
      document.body.appendChild(toggleButton);
      
      // Add click event listener
      toggleButton.addEventListener('click', () => {
        this.toggleDesktopTranslate();
      });
    }
    
    // Update button state and position based on current translate state
    const translateIframe = document.querySelector('iframe.VIpgJd-ZVi9od-ORHb-OEVmcd') as HTMLElement;
    const bannerFrame = document.querySelector('.goog-te-banner-frame') as HTMLElement;
    
    // Check if translate is collapsed
    const isCollapsed = (translateIframe && translateIframe.classList.contains('translate-collapsed')) ||
                       (bannerFrame && bannerFrame.classList.contains('translate-collapsed'));
    
    if (isCollapsed) {
      toggleButton.classList.add('collapsed');
      toggleButton.style.top = '14px'; // Position at header level
    } else {
      toggleButton.classList.remove('collapsed');
      toggleButton.style.top = '74px'; // Position below translate section
    }
    
    // Ensure button is always visible
    toggleButton.style.display = 'flex';
    toggleButton.style.visibility = 'visible';
    toggleButton.style.opacity = '1';
  }
  
  toggleHeaderTranslate(): void {
    if (this.isMobileView || !this.selectedLanguage) {
      return;
    }
    
    this.isHeaderTranslateExpanded = !this.isHeaderTranslateExpanded;
    
    const translateIframe = document.querySelector('iframe.VIpgJd-ZVi9od-ORHb-OEVmcd') as HTMLElement;
    const bannerFrame = document.querySelector('.goog-te-banner-frame') as HTMLElement;
    const headerTranslateContainer = document.querySelector('.header-translate-container') as HTMLElement;
    const headerTranslateElement = document.getElementById('google_translate_element_header');
    
    if (this.isHeaderTranslateExpanded) {
      // Expand - Show translate widget in header
      // Hide the banner/iframe above header to prevent blocking
      if (translateIframe) {
        translateIframe.style.display = 'none';
        translateIframe.style.visibility = 'hidden';
        translateIframe.classList.add('translate-collapsed');
      }
      if (bannerFrame) {
        bannerFrame.style.display = 'none';
        bannerFrame.style.visibility = 'hidden';
        bannerFrame.classList.add('translate-collapsed');
      }
      
      // Ensure translate widget is visible in header container
      setTimeout(() => {
        if (headerTranslateElement) {
          headerTranslateElement.style.display = 'block';
          headerTranslateElement.style.visibility = 'visible';
          headerTranslateElement.style.opacity = '1';
          
          // Make sure all children are visible
          const allChildren = headerTranslateElement.querySelectorAll('*');
          allChildren.forEach((el: any) => {
            if (el && el.style) {
              el.style.display = '';
              el.style.visibility = 'visible';
              el.style.opacity = '1';
            }
          });
          
          // If widget doesn't exist, try to initialize it
          if (!headerTranslateElement.querySelector('.goog-te-gadget')) {
            // Try to find existing translate widget and move it
            const existingTranslate = document.querySelector('#google_translate_element_header_fallback, #google_translate_element');
            if (existingTranslate) {
              const gadget = existingTranslate.querySelector('.goog-te-gadget');
              if (gadget && !headerTranslateElement.querySelector('.goog-te-gadget')) {
                const clonedGadget = gadget.cloneNode(true) as HTMLElement;
                headerTranslateElement.appendChild(clonedGadget);
              }
            } else if (typeof window !== 'undefined' && (window as any).google && (window as any).google.translate) {
              // Initialize if not already done
              try {
                new (window as any).google.translate.TranslateElement(
                  {
                    pageLanguage: 'en',
                    includedLanguages: 'en,es,fr,de,it,pt,ru,ja,ko,zh-CN,ar,hi,tr',
                  },
                  'google_translate_element_header'
                );
              } catch (e) {
                console.log('Translate initialization error:', e);
              }
            }
          }
        }
      }, 100);
    } else {
      // Collapse - Hide translate widget in header
      if (headerTranslateElement) {
        headerTranslateElement.style.display = 'none';
        headerTranslateElement.style.visibility = 'hidden';
        headerTranslateElement.style.opacity = '0';
      }
    }
  }
  
  toggleDesktopTranslate(): void {
    // Existing behavior: toggle Google Translate iframe/banner visibility
    // If header translate is expanded, collapse it first
    if (this.isHeaderTranslateExpanded) {
      this.isHeaderTranslateExpanded = false;
    }
    
    const translateIframe = document.querySelector('iframe.VIpgJd-ZVi9od-ORHb-OEVmcd') as HTMLElement;
    const bannerFrame = document.querySelector('.goog-te-banner-frame') as HTMLElement;
    
    // Determine current collapsed state
    const isCurrentlyCollapsed = 
      (translateIframe && translateIframe.classList.contains('translate-collapsed')) ||
      (bannerFrame && bannerFrame.classList.contains('translate-collapsed'));
    
    // Toggle the state - when collapsed, expand; when expanded, collapse
    this.isTranslateBannerCollapsed = isCurrentlyCollapsed;
    
    // Toggle collapsed state
    if (translateIframe) {
      if (isCurrentlyCollapsed) {
        // Expand - Show translate iframe above header
        translateIframe.classList.remove('translate-collapsed');
        translateIframe.style.display = 'block';
        translateIframe.style.visibility = 'visible';
        translateIframe.style.opacity = '1';
        translateIframe.style.height = '60px';
        this.isTranslateBannerCollapsed = false;
      } else {
        // Collapse - Hide translate iframe, icon shows in header instead
        translateIframe.classList.add('translate-collapsed');
        translateIframe.style.display = 'none';
        translateIframe.style.visibility = 'hidden';
        translateIframe.style.opacity = '0';
        translateIframe.style.height = '0';
        this.isTranslateBannerCollapsed = true;
      }
    }
    
    // Handle banner frame separately
    if (bannerFrame) {
      if (isCurrentlyCollapsed) {
        // Expand
        bannerFrame.classList.remove('translate-collapsed');
        bannerFrame.style.display = 'block';
        bannerFrame.style.visibility = 'visible';
        bannerFrame.style.opacity = '1';
        bannerFrame.style.height = '60px';
        this.isTranslateBannerCollapsed = false;
      } else {
        // Collapse
        bannerFrame.classList.add('translate-collapsed');
        bannerFrame.style.display = 'none';
        bannerFrame.style.visibility = 'hidden';
        bannerFrame.style.opacity = '0';
        bannerFrame.style.height = '0';
        this.isTranslateBannerCollapsed = true;
      }
    }
  }

  /* Desktop language selection modal helpers (custom UI) */
  openLanguageModal(): void {
    // Reset search term whenever modal opens
    this.languageSearchTerm = "";

    // Desktop: show all languages at once
    // Mobile: show first page (20) and load more on scroll
    if (this.isMobileView) {
      this.languageLoadedCount = 0;
      this.visibleLanguageOptions = [];
      this.loadMoreLanguages();
    } else {
      this.visibleLanguageOptions = [...this.languageOptions];
      this.languageLoadedCount = this.languageOptions.length;
    }
    this.showDesktopLanguageModal = true;
    this.cdr.markForCheck();
  }

  closeLanguageModal(): void {
    this.showDesktopLanguageModal = false;
    this.cdr.markForCheck();
  }

  applyLanguageFromModal(code: string): void {
    this.ensureTranslationApplied(code);
    this.showDesktopLanguageModal = false;
    this.cdr.markForCheck();
  }

  onLanguageSearchChange(term: string): void {
    const value = (term || "").trim().toLowerCase();
    this.languageSearchTerm = term || "";

    // Empty search: restore default paginated / full list behaviour
    if (!value) {
      if (this.isMobileView) {
        this.languageLoadedCount = 0;
        this.visibleLanguageOptions = [];
        this.loadMoreLanguages();
      } else {
        this.visibleLanguageOptions = [...this.languageOptions];
        this.languageLoadedCount = this.languageOptions.length;
      }
      return;
    }

    // Filter full language list by display name as user types
    this.visibleLanguageOptions = this.languageOptions.filter((lang) =>
      (lang.name || "").toLowerCase().includes(value)
    );
  }

  clearLanguageSearch(): void {
    this.onLanguageSearchChange("");
  }

  // Load next page of languages into the modal list
  loadMoreLanguages(): void {
    if (!this.languageOptions || this.languageLoadedCount >= this.languageOptions.length) {
      return;
    }

    const nextEnd = Math.min(
      this.languageLoadedCount + this.languagePageSize,
      this.languageOptions.length
    );
    const nextSlice = this.languageOptions.slice(this.languageLoadedCount, nextEnd);

    if (!this.visibleLanguageOptions) {
      this.visibleLanguageOptions = [];
    }
    this.visibleLanguageOptions = [...this.visibleLanguageOptions, ...nextSlice];
    this.languageLoadedCount = nextEnd;
  }

  onLanguageListScroll(event: Event): void {
    // Only paginate on mobile; desktop always shows full list
    if (!this.isMobileView) return;

    const target = event.target as HTMLElement;
    if (!target) return;

    const threshold = 40; // px from bottom to trigger load more
    const position = target.scrollTop + target.clientHeight;
    const height = target.scrollHeight;

    if (height - position <= threshold) {
      this.loadMoreLanguages();
    }
  }

  initializeGoogleTranslate(): void {
    // Only initialize on desktop
    if (this.isMobileView) {
      return;
    }

    // Wait for Google Translate script to load and initialize in header
    if (
      typeof window !== "undefined" &&
      (window as any).google &&
      (window as any).google.translate
    ) {
      // Initialize in appropriate element based on language selection
      const targetElementId = this.selectedLanguage 
        ? "google_translate_element_header" 
        : "google_translate_element_header_fallback";
      
      const headerElement = document.getElementById(targetElementId);
      if (headerElement) {
        // Ensure header element is visible
        headerElement.style.display = "block";
        headerElement.style.visibility = "visible";
        headerElement.style.opacity = "1";

        if (
          !headerElement.hasChildNodes() &&
          !this.googleTranslateInitialized
        ) {
          try {
            new (window as any).google.translate.TranslateElement(
              {
                pageLanguage: "en",
                includedLanguages: "en,es,fr,de,it,pt,ru,ja,ko,zh-CN,ar,hi,tr",
              },
              targetElementId
            );
            this.googleTranslateInitialized = true;

            // Ensure visibility after initialization
            setTimeout(() => {
              if (headerElement) {
                headerElement.style.display = "block";
                headerElement.style.visibility = "visible";
                const allChildren = headerElement.querySelectorAll("*");
                allChildren.forEach((el: any) => {
                  if (el && el.style) {
                    el.style.display = "";
                    el.style.visibility = "visible";
                    el.style.opacity = "1";
                  }
                });

                // Add event listeners for language selection (same as mobile)
                this.setupTranslateEventListeners(headerElement);

                // Also add direct change listener for desktop (same as mobile)
                const selectElement = headerElement.querySelector(
                  ".goog-te-combo"
                ) as HTMLSelectElement;
                if (selectElement) {
                  // Remove existing listeners to avoid duplicates
                  selectElement.removeEventListener(
                    "change",
                    this.handleDesktopTranslateChange
                  );
                  // Add new listener for desktop
                  selectElement.addEventListener(
                    "change",
                    this.handleDesktopTranslateChange
                  );
                }
              }
            }, 200);
          } catch (e) {
            console.log("Google Translate initialization error:", e);
          }
        } else if (headerElement.hasChildNodes()) {
          // Already initialized, just ensure visibility
          headerElement.style.display = "block";
          headerElement.style.visibility = "visible";
        }
      }
    } else {
      // If script hasn't loaded yet, wait and retry (max 5 seconds)
      if (!this.googleTranslateInitialized) {
        setTimeout(() => {
          if (!this.googleTranslateInitialized) {
            this.initializeGoogleTranslate();
          }
        }, 500);
      }
    }
  }

  fixMobileTranslatePosition(): void {
    // On mobile, hide the default translate element (we use floating button instead)
    if (this.isMobileView) {
      const translateElement = document.getElementById(
        "google_translate_element"
      );
      if (translateElement) {
        // Hide the default translate element on mobile
        translateElement.style.display = "none";
      }

      // Ensure mobile translate button is always visible
      const mobileTranslateBtn = document.querySelector(
        ".mobile-translate-floating-btn"
      );
      if (mobileTranslateBtn) {
        (mobileTranslateBtn as HTMLElement).style.display = "flex";
        (mobileTranslateBtn as HTMLElement).style.visibility = "visible";
        (mobileTranslateBtn as HTMLElement).style.opacity = "1";
      }
    } else {
      // Desktop: Ensure header translate element is visible
      const headerElement = document.getElementById(
        "google_translate_element_header"
      );
      if (headerElement) {
        headerElement.style.display = "block";
        headerElement.style.visibility = "visible";
        headerElement.style.opacity = "1";
      }

      // Reset on desktop - show default translate element (but keep it hidden as we use header)
      const translateElement = document.getElementById(
        "google_translate_element"
      );
      if (translateElement) {
        translateElement.style.display = "none"; // Keep hidden, we use header element
        translateElement.style.position = "";
        translateElement.style.top = "";
        translateElement.style.left = "";
        translateElement.style.right = "";
        translateElement.style.zIndex = "";
        translateElement.style.backgroundColor = "";
        translateElement.style.padding = "";
        translateElement.style.borderBottom = "";
        translateElement.style.boxShadow = "";
      }

      // Hide mobile translate when switching to desktop
      this.showMobileTranslate = false;
      this.mobileTranslateInitialized = false; // Reset flag when switching to desktop

      // Clear mobile container
      const mobileContainer = document.getElementById(
        "google_translate_element_mobile"
      );
      if (mobileContainer) {
        mobileContainer.innerHTML = "";
      }

      // Reset content margin
      const mainContent = document.querySelector(".app-main-content");
      if (mainContent) {
        (mainContent as HTMLElement).style.marginTop = "";
        (mainContent as HTMLElement).style.paddingTop = "";
      }
      // Reset category filter bar position
      const categoryFilterBar = document.querySelector(
        ".category-filter-bar"
      ) as HTMLElement;
      if (categoryFilterBar) {
        categoryFilterBar.style.top = "";
        categoryFilterBar.style.marginTop = "";
        categoryFilterBar.style.position = "";
        categoryFilterBar.style.zIndex = "";
        categoryFilterBar.style.backgroundColor = "";
      }
    }
  }

  // Legacy toggleMobileTranslate removed - mobile now uses the same
  // sidebar Language option and modal as desktop.

  ensureTranslateWidgetVisible(): void {
    const mobileContainer = document.getElementById(
      "google_translate_element_mobile"
    );
    if (!mobileContainer) {
      setTimeout(() => this.ensureTranslateWidgetVisible(), 100);
      return;
    }

    // Check if container has content
    const hasContent =
      mobileContainer.children.length > 0 &&
      mobileContainer.innerHTML.trim() !== "" &&
      mobileContainer.querySelector(".goog-te-gadget");

    if (!hasContent) {
      // Container is empty, need to initialize or move
      const originalElement = document.getElementById(
        "google_translate_element"
      );

      if (
        originalElement &&
        (originalElement.children.length > 0 ||
          originalElement.innerHTML.trim() !== "")
      ) {
        // Move from original
        this.moveTranslateToMobile();
      } else if (!this.mobileTranslateInitialized) {
        // Initialize new widget
        this.initializeMobileTranslate();
      } else {
        // Try to re-initialize
        this.initializeMobileTranslate();
      }
    } else {
      // Container has content, ensure it's visible
      this.makeTranslateWidgetVisible(mobileContainer);
    }
  }

  makeTranslateWidgetVisible(container: HTMLElement): void {
    // Ensure container itself is visible
    container.style.display = "block";
    container.style.visibility = "visible";
    container.style.opacity = "1";

    // Ensure all children are visible
    const allChildren = container.querySelectorAll("*");
    allChildren.forEach((el: any) => {
      if (el && el.style) {
        if (el.style.display === "none") {
          el.style.display = "";
        }
        if (el.style.visibility === "hidden") {
          el.style.visibility = "visible";
        }
        el.style.opacity = "1";
      }
    });

    // Specifically ensure Google Translate elements are visible
    const googTeGadget = container.querySelector(".goog-te-gadget");
    if (googTeGadget) {
      (googTeGadget as HTMLElement).style.display = "block";
      (googTeGadget as HTMLElement).style.visibility = "visible";
      (googTeGadget as HTMLElement).style.opacity = "1";
    }

    const googTeGadgetSimple = container.querySelector(
      ".goog-te-gadget-simple"
    );
    if (googTeGadgetSimple) {
      (googTeGadgetSimple as HTMLElement).style.display = "flex";
      (googTeGadgetSimple as HTMLElement).style.visibility = "visible";
      (googTeGadgetSimple as HTMLElement).style.opacity = "1";
    }

    const googTeCombo = container.querySelector(".goog-te-combo");
    if (googTeCombo) {
      (googTeCombo as HTMLElement).style.display = "block";
      (googTeCombo as HTMLElement).style.visibility = "visible";
      (googTeCombo as HTMLElement).style.opacity = "1";
    }

    // Force a re-render by triggering a resize or reflow
    setTimeout(() => {
      container.style.display = "block";
      if (googTeGadget) {
        (googTeGadget as HTMLElement).offsetHeight; // Force reflow
      }
    }, 50);
  }

  ensureTranslateVisible(): void {
    const mobileContainer = document.getElementById(
      "google_translate_element_mobile"
    );
    if (!mobileContainer) {
      return;
    }

    // If container is empty, try to move from original or re-initialize
    if (
      mobileContainer.children.length === 0 ||
      mobileContainer.innerHTML.trim() === ""
    ) {
      // Try to move from original first
      const originalElement = document.getElementById(
        "google_translate_element"
      );
      if (
        originalElement &&
        (originalElement.children.length > 0 ||
          originalElement.innerHTML.trim() !== "")
      ) {
        this.moveTranslateToMobile();
      } else {
        // Re-initialize if original is also empty
        this.initializeMobileTranslate();
      }
    } else {
      // Use the new function to ensure visibility
      this.makeTranslateWidgetVisible(mobileContainer);
    }
  }

  initializeMobileTranslate(): void {
    const mobileContainer = document.getElementById(
      "google_translate_element_mobile"
    );
    const originalElement = document.getElementById("google_translate_element");

    if (!mobileContainer) {
      setTimeout(() => {
        this.initializeMobileTranslate();
      }, 100);
      return;
    }

    // First, try to move the existing translate widget from original element
    if (
      originalElement &&
      (originalElement.children.length > 0 ||
        originalElement.innerHTML.trim() !== "")
    ) {
      this.moveTranslateToMobile();
      this.mobileTranslateInitialized = true;
      return;
    }

    // If original element is empty, wait a bit for it to initialize, then move it
    setTimeout(() => {
      if (
        originalElement &&
        (originalElement.children.length > 0 ||
          originalElement.innerHTML.trim() !== "")
      ) {
        this.moveTranslateToMobile();
        this.mobileTranslateInitialized = true;
      } else {
        // If still empty after waiting, try to initialize directly
        this.initializeTranslateDirectly();
      }
    }, 300);
  }

  initializeTranslateDirectly(): void {
    const mobileContainer = document.getElementById(
      "google_translate_element_mobile"
    );

    if (!mobileContainer) {
      return;
    }

    // Clear any existing content
    mobileContainer.innerHTML = "";

    // Check if Google Translate is available
    if (
      typeof window !== "undefined" &&
      (window as any).google &&
      (window as any).google.translate
    ) {
      try {
        // Initialize translate widget directly in mobile container
        new (window as any).google.translate.TranslateElement(
          {
            pageLanguage: "en",
            includedLanguages: "en,es,fr,de,it,pt,ru,ja,ko,zh-CN,ar,hi,tr",
            layout: (window as any).google.translate.TranslateElement
              .InlineLayout.SIMPLE,
            autoDisplay: true, // Allow auto-display
          },
          "google_translate_element_mobile"
        );
        this.mobileTranslateInitialized = true;

        // Ensure visibility
        setTimeout(() => {
          const allChildren = mobileContainer.querySelectorAll("*");
          allChildren.forEach((el: any) => {
            if (el && el.style) {
              el.style.display = "";
              el.style.visibility = "visible";
              el.style.opacity = "1";
            }
          });

          // Add event listeners for language selection
          this.setupTranslateEventListeners(mobileContainer);

          // Also set up mobile-specific monitoring immediately
          if (this.isMobileView) {
            this.setupMobileLanguageMonitoring();
          }

          // Add direct click listener to the select dropdown for mobile
          const selectElement = mobileContainer.querySelector(
            ".goog-te-combo"
          ) as HTMLSelectElement;
          if (selectElement) {
            // Remove existing listeners to avoid duplicates
            const newSelectElement = selectElement.cloneNode(
              true
            ) as HTMLSelectElement;
            selectElement.parentNode.replaceChild(
              newSelectElement,
              selectElement
            );

            newSelectElement.addEventListener("change", (e) => {
              const target = e.target as HTMLSelectElement;
              const selectedLang = target.value;
              if (selectedLang && selectedLang !== "") {
                // Apply translation without reload
                this.ensureTranslationApplied(selectedLang);
              } else if (selectedLang === "") {
                // Reset to English
                this.selectedLanguage = null;
                this.selectedLanguageName = null;
                document.cookie = `googtrans=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT`;
                window.location.hash = "";
                this.cdr.detectChanges();
              }
            });
          }
        }, 200);
      } catch (e) {
        console.log("Google Translate mobile initialization error:", e);
      }
    } else {
      // Wait for script to load and retry
      setTimeout(() => {
        this.initializeTranslateDirectly();
      }, 500);
    }
  }

  moveTranslateToMobile(): void {
    const originalElement = document.getElementById("google_translate_element");
    const mobileContainer = document.getElementById(
      "google_translate_element_mobile"
    );

    if (!originalElement || !mobileContainer) {
      return;
    }

    // Instead of copying HTML (which breaks functionality),
    // move the actual DOM nodes to preserve Google Translate functionality
    if (
      originalElement.children.length > 0 ||
      originalElement.innerHTML.trim() !== ""
    ) {
      // Clear mobile container first
      mobileContainer.innerHTML = "";

      // Move actual DOM nodes (not copy HTML) to preserve functionality
      while (originalElement.firstChild) {
        mobileContainer.appendChild(originalElement.firstChild);
      }

      // Ensure container is visible
      mobileContainer.style.display = "block";
      mobileContainer.style.visibility = "visible";
      mobileContainer.style.opacity = "1";

      // Force visibility on all child elements and ensure they're properly styled
      setTimeout(() => {
        const allChildren = mobileContainer.querySelectorAll("*");
        allChildren.forEach((el: any) => {
          if (el && el.style) {
            // Remove any display:none or visibility:hidden
            if (el.style.display === "none") {
              el.style.display = "";
            }
            if (el.style.visibility === "hidden") {
              el.style.visibility = "visible";
            }
            el.style.opacity = "1";
          }
        });

        // Specifically ensure Google Translate elements are visible
        const googTeGadget = mobileContainer.querySelector(".goog-te-gadget");
        if (googTeGadget) {
          (googTeGadget as HTMLElement).style.display = "block";
          (googTeGadget as HTMLElement).style.visibility = "visible";
        }

        const googTeGadgetSimple = mobileContainer.querySelector(
          ".goog-te-gadget-simple"
        );
        if (googTeGadgetSimple) {
          (googTeGadgetSimple as HTMLElement).style.display = "flex";
          (googTeGadgetSimple as HTMLElement).style.visibility = "visible";
        }

        // Add event listeners for language selection on mobile
        this.setupTranslateEventListeners(mobileContainer);

        // Add direct listener to select dropdown
        const selectElement = mobileContainer.querySelector(
          ".goog-te-combo"
        ) as HTMLSelectElement;
        if (selectElement) {
          // Remove existing listeners to avoid duplicates
          const newSelectElement = selectElement.cloneNode(
            true
          ) as HTMLSelectElement;
          selectElement.parentNode.replaceChild(
            newSelectElement,
            selectElement
          );

          newSelectElement.addEventListener("change", (e) => {
            const target = e.target as HTMLSelectElement;
            const selectedLang = target.value;
            if (selectedLang && selectedLang !== "") {
              // Apply translation without reload
              this.ensureTranslationApplied(selectedLang);
            } else if (selectedLang === "") {
              // Reset to English
              this.selectedLanguage = null;
              this.selectedLanguageName = null;
              document.cookie = `googtrans=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT`;
              window.location.hash = "";
              this.cdr.detectChanges();
            }
          });
        }

        // Also set up mobile-specific monitoring (important for mobile where iframe access might be blocked)
        if (this.isMobileView) {
          this.setupMobileLanguageMonitoring();
        }
      }, 100);

      // Keep original element in DOM but hidden (Google Translate might need it)
      originalElement.style.display = "none";
      originalElement.style.visibility = "hidden";
      originalElement.style.position = "absolute";
      originalElement.style.left = "-9999px";
      this.mobileTranslateInitialized = true;
    }
  }

  moveTranslateBack(): void {
    const originalElement = document.getElementById("google_translate_element");
    const mobileContainer = document.getElementById(
      "google_translate_element_mobile"
    );

    if (mobileContainer) {
      // Clear mobile container
      mobileContainer.innerHTML = "";
    }

    // If we initialized mobile translate separately, we don't need to move back
    // The original element should remain hidden on mobile
    if (originalElement && this.isMobileView) {
      originalElement.style.display = "none";
    }
  }

  adjustContentForTranslateBanner(): void {
    // Check if translate banner is visible and adjust content accordingly
    setTimeout(() => {
      if (!this.isMobileView) {
        return;
      }

      const bannerFrame = document.querySelector(
        ".goog-te-banner-frame"
      ) as HTMLElement;
      const mainContent = document.querySelector(
        ".app-main-content"
      ) as HTMLElement;
      const header = document.querySelector(".app-header") as HTMLElement;
      const categoryFilterBar = document.querySelector(
        ".category-filter-bar"
      ) as HTMLElement;

      if (mainContent) {
        const headerHeight = header ? header.offsetHeight : 56;

        if (bannerFrame && bannerFrame.offsetHeight > 0) {
          // Banner is at footer - add bottom padding instead of top
          const bannerHeight = bannerFrame.offsetHeight;
          mainContent.style.paddingTop = headerHeight + "px";
          mainContent.style.paddingBottom = bannerHeight + 76 + "px"; // Banner height + floating button space

          // Category filter bar stays at top (no change needed)
          if (categoryFilterBar) {
            categoryFilterBar.style.top = headerHeight + "px";
            categoryFilterBar.style.marginTop = "6px";
            categoryFilterBar.style.position = "sticky";
            categoryFilterBar.style.zIndex = "999";
            categoryFilterBar.style.backgroundColor = "";
          }

          // Ensure banner is positioned at bottom
          bannerFrame.style.position = "fixed";
          bannerFrame.style.bottom = "0";
          bannerFrame.style.top = "auto";
          bannerFrame.style.marginBottom = "76px";
        } else {
          // No banner - use normal padding
          mainContent.style.paddingTop = headerHeight + "px";
          mainContent.style.paddingBottom = "76px"; // Just space for floating button

          // Reset category filter bar position
          if (categoryFilterBar) {
            categoryFilterBar.style.top = headerHeight + "px";
            categoryFilterBar.style.marginTop = "6px";
            categoryFilterBar.style.position = "sticky";
            categoryFilterBar.style.zIndex = "999";
            categoryFilterBar.style.backgroundColor = "";
          }
        }
      }
    }, 300);
  }

  @HostListener("window:resize", ["$event"])
  getScreenSize(event?) {
    this.onResize(event);
  }

  @HostListener("document:click", ["$event"])
  @HostListener("document:touchend", ["$event"])
  onDocumentClick(event: MouseEvent | TouchEvent) {
    if (!this.isMobileView) {
      return;
    }

    const target = event.target as HTMLElement;

    // Handle mobile search close - only close when clicking outside AND no text in search
    if (this.showMobileSearch) {
      const insideSearchBox = !!target.closest(".mobile-search-box-in-header");
      const insideSearchField = !!target.closest(".mobile-search-field");
      const isHeaderSearchButton = !!target.closest(
        ".app-search-container .search-button"
      );
      const isBackButton = !!target.closest(".menu-button");

      // Keep search box open while there is text.
      const hasText =
        this.searchInput && this.searchInput.trim() !== "";

      // Only close when:
      // - Click is outside search box/field and not the header search button or back button
      // - AND there is no text in the search box
      if (!insideSearchBox && !insideSearchField && !isHeaderSearchButton && !isBackButton && !hasText) {
        this.showMobileSearch = false;
      }
    }

    // Close category selector dropdown when clicking outside
    const insideCategorySelector = !!(event.target as HTMLElement).closest('.search-category-selector');
    if (!insideCategorySelector && this.showCategoryDropdown) {
      this.showCategoryDropdown = false;
    }

    // Handle mobile translate close
  }
  onResize(event) {
    const width = window.innerWidth || document.body.clientWidth;
    // Align mobile breakpoint with search page (<= 955 considered mobile/tablet)
    const isMobile = width <= 955;
    const wasMobile = this.isMobileView;
    this.isMobileView = isMobile;
    if (!isMobile) {
      this.showMobileSearch = false; // ensure search bar hides when switching to desktop
      // Re-initialize Google Translate when switching to desktop
      if (wasMobile && !this.googleTranslateInitialized) {
        setTimeout(() => this.initializeGoogleTranslate(), 100);
      }
      // Reset mobile translate positioning
      this.fixMobileTranslatePosition();
    } else {
      // Reset initialization flag when switching to mobile
      this.googleTranslateInitialized = false;
      // Fix mobile translate positioning
      setTimeout(() => this.fixMobileTranslatePosition(), 100);
    }
    // On mobile, sidebar should be closed by default
    if (isMobile) {
      this.sidebarCollapsed = true;
    }
    this.syncTranslateUiOnResize();
  }

  ChangeLanguage(value) {
    // this.translateService.setDefaultLang(value);
    // this.translateService.use(value);
  }

  setupTranslateEventListeners(container: HTMLElement): void {
    // Listen for clicks on the translate dropdown
    const translateSelect = container.querySelector(".goog-te-menu-value");
    if (translateSelect) {
      translateSelect.addEventListener("click", () => {
        // When dropdown is clicked, set up listener for language selection
        setTimeout(() => {
          this.listenForLanguageMenu();
        }, 300);
      });
    }

    // For both mobile and desktop, listen directly to the select dropdown change event
    const selectElement = container.querySelector(
      ".goog-te-combo"
    ) as HTMLSelectElement;
    if (selectElement) {
      if (this.isMobileView) {
        // Remove existing listener to prevent duplicates
        selectElement.removeEventListener(
          "change",
          this.handleMobileTranslateChange
        );
        // Add new listener for mobile
        selectElement.addEventListener(
          "change",
          this.handleMobileTranslateChange
        );
      } else {
        // Remove existing listener to prevent duplicates
        selectElement.removeEventListener(
          "change",
          this.handleDesktopTranslateChange
        );
        // Add new listener for desktop (same as mobile)
        selectElement.addEventListener(
          "change",
          this.handleDesktopTranslateChange
        );
      }
    }

    // Listen for URL hash changes (Google Translate uses hash for language)
    // This is the primary way Google Translate triggers translation
    // Especially important for mobile where iframe access might be blocked
    const hashChangeHandler = () => {
      const hash = window.location.hash;
      if (hash.includes("googtrans")) {
        // Language was selected, extract and ensure translation is applied
        const match = hash.match(/googtrans\(en\|([^)]+)\)/);
        if (match && match[1]) {
          const targetLang = match[1];
          // Google Translate should automatically translate, but ensure it happens
          // For both mobile and desktop, immediately ensure translation is applied
            this.ensureTranslationApplied(targetLang);
        }
      }
    };

    // Add hashchange listener (only once globally)
    if (!(window as any).__translateHashListenerAdded) {
      window.addEventListener("hashchange", hashChangeHandler);
      (window as any).__translateHashListenerAdded = true;
    }

    // Also check hash on load and periodically (important for mobile)
    setTimeout(() => {
      hashChangeHandler();
    }, 1000);

    // For mobile, monitor hash changes (some mobile browsers miss hashchange events).
    if (this.isMobileView) {
      let lastHash = window.location.hash;
      this.trackPerformanceInterval(() => {
        const currentHash = window.location.hash;
        if (currentHash !== lastHash) {
          lastHash = currentHash;
          hashChangeHandler();
        }
      }, 1500);
    }

    // Monitor cookie changes (Google Translate stores language in cookie)
    let lastCookie = document.cookie;
    let lastHash = window.location.hash;

    const cookieCheckInterval = this.trackPerformanceInterval(() => {
      const currentCookie = document.cookie;
      const currentHash = window.location.hash;

      if (currentCookie !== lastCookie) {
        lastCookie = currentCookie;
        const selectedLang = this.getCurrentTranslateLanguage();
        if (selectedLang && selectedLang !== "en") {
          this.ensureTranslationApplied(selectedLang);
        }
      }

      if (currentHash !== lastHash && currentHash.includes("googtrans")) {
        lastHash = currentHash;
        const match = currentHash.match(/googtrans\(en\|([^)]+)\)/);
        if (match && match[1]) {
          this.ensureTranslationApplied(match[1]);
        }
      }
    }, 1500);

    (container as any).__translateCookieInterval = cookieCheckInterval;

    // Listen for clicks anywhere in the container (to catch menu clicks)
    container.addEventListener("click", (e) => {
      const target = e.target as HTMLElement;
      if (
        target &&
        (target.classList.contains("goog-te-menu-value") ||
          target.closest(".goog-te-menu-value"))
      ) {
        setTimeout(() => {
          this.listenForLanguageMenu();
        }, 500);
      }
    });
  }

  listenForLanguageMenu(): void {
    // Try to find and listen to the language menu
    const menuFrame = document.querySelector(".goog-te-menu-frame");
    if (menuFrame) {
      const iframe = menuFrame.querySelector("iframe");
      if (iframe) {
        // Check if iframe is already loaded
        try {
          if (iframe.contentDocument || iframe.contentWindow?.document) {
            this.attachLanguageMenuListeners(iframe);
          } else {
            // Wait for iframe to load
            iframe.addEventListener("load", () => {
              this.attachLanguageMenuListeners(iframe);
            });
          }
        } catch (e) {
          // Iframe access blocked (common on mobile), use alternative monitoring
          this.setupMobileLanguageMonitoring();
        }
      } else {
        // No iframe yet, monitor for its appearance
        this.setupMobileLanguageMonitoring();
      }
    } else {
      // Menu frame doesn't exist yet, set up monitoring
      this.setupMobileLanguageMonitoring();
    }

    // Also monitor for menu frame appearance
    const observer = new MutationObserver(() => {
      const menuFrame = document.querySelector(".goog-te-menu-frame");
      if (menuFrame) {
        const iframe = menuFrame.querySelector("iframe");
        if (iframe) {
          try {
            this.attachLanguageMenuListeners(iframe);
          } catch (e) {
            this.setupMobileLanguageMonitoring();
          }
          observer.disconnect();
        }
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
    this.trackPerformanceObserver(observer);
    setTimeout(() => observer.disconnect(), 20000);
  }

  setupMobileLanguageMonitoring(): void {
    let lastHash = window.location.hash;
    let lastCookie = document.cookie;
    let hashChangeDetected = false;

    if ((window as any).__mobileTranslateMonitor) {
      clearInterval((window as any).__mobileTranslateMonitor);
    }

    let checks = 0;
    const maxChecks = 60;

    const mobileMonitorInterval = this.trackPerformanceInterval(() => {
      checks += 1;
      const currentHash = window.location.hash;
      const currentCookie = document.cookie;

      if (currentHash !== lastHash && currentHash.includes("googtrans")) {
        lastHash = currentHash;
        hashChangeDetected = true;
        const match = currentHash.match(/googtrans\(en\|([^)]+)\)/);
        if (match && match[1]) {
          const targetLang = match[1];
          if (this.isMobileView) {
            document.cookie = `googtrans=/en/${targetLang}; path=/; max-age=31536000`;
            setTimeout(() => {
              window.location.reload();
            }, 100);
          } else {
            this.triggerTranslationWithoutReload(targetLang);
            setTimeout(() => {
              this.moveBannerToFooter();
              this.moveTranslateIframeToFooter();
            }, 500);
          }
          return;
        }
      }

      if (currentCookie !== lastCookie) {
        lastCookie = currentCookie;
        const selectedLang = this.getCurrentTranslateLanguage();
        if (selectedLang && selectedLang !== "en" && !hashChangeDetected) {
          window.location.hash = `googtrans(en|${selectedLang})`;
          if (this.isMobileView) {
            setTimeout(() => {
              window.location.reload();
            }, 100);
          } else {
            this.triggerTranslationWithoutReload(selectedLang);
            setTimeout(() => {
              this.moveBannerToFooter();
              this.moveTranslateIframeToFooter();
            }, 500);
          }
        }
      }

      if (checks >= maxChecks) {
        clearInterval(mobileMonitorInterval);
        if ((window as any).__mobileTranslateMonitor === mobileMonitorInterval) {
          (window as any).__mobileTranslateMonitor = null;
        }
      }
    }, 500);

    (window as any).__mobileTranslateMonitor = mobileMonitorInterval;
  }

  attachLanguageMenuListeners(iframe: HTMLIFrameElement): void {
    try {
      const iframeDoc =
        iframe.contentDocument || iframe.contentWindow?.document;
      if (iframeDoc) {
        const links = iframeDoc.querySelectorAll("a");
        links.forEach((link) => {
          // Don't prevent default - let Google Translate handle it naturally
          // Just monitor for the click and ensure translation is applied
          link.addEventListener("click", (e) => {
            const href = (link as HTMLAnchorElement).getAttribute("href");
            if (href && href.includes("googtrans")) {
              // Extract language from href
              const match = href.match(/googtrans\(en\|([^)]+)\)/);
              if (match && match[1]) {
                const targetLang = match[1];

                // Don't prevent default - let Google Translate's default behavior work
                // Just ensure translation is applied after a short delay
                setTimeout(() => {
                  // Check if hash was set (Google Translate should do this)
                  const hash = window.location.hash;
                  if (!hash.includes(`googtrans(en|${targetLang})`)) {
                    // If hash wasn't set, set it manually
                    window.location.hash = `googtrans(en|${targetLang})`;
                  }

                  // Ensure cookie is set
                  document.cookie = `googtrans=/en/${targetLang}; path=/; max-age=31536000`;

                  // Use triggerTranslationWithoutReload for desktop, reload only on mobile
                  if (this.isMobileView) {
                  // Check if translation is active after a delay
                  setTimeout(() => {
                    const isTranslated =
                      document.body.classList.contains("translated-ltr") ||
                      document.body.classList.contains("translated-rtl");
                    if (!isTranslated) {
                        // Translation didn't apply, reload page (mobile only)
                      window.location.reload();
                    }
                  }, 500);
                  } else {
                    // Desktop: trigger translation without reload
                    this.triggerTranslationWithoutReload(targetLang);
                    setTimeout(() => {
                      this.moveBannerToFooter();
                      this.moveTranslateIframeToFooter();
                    }, 500);
                  }
                }, 100);
              }
            }
          });
        });
      }
    } catch (e) {
      // Cross-origin restrictions on mobile - use cookie/hash monitoring instead
      // This is expected on mobile, so we rely on hash/cookie monitoring
      console.log(
        "Cannot access iframe (expected on mobile), using cookie/hash monitoring"
      );
    }
  }

  setupAlternativeTranslateListener(): void {
    this.trackPerformanceInterval(() => {
      const currentLang = this.getCurrentTranslateLanguage();
      if (currentLang && currentLang !== "en") {
        this.ensureTranslationActive();
      }
    }, 5000);
  }

  getCurrentTranslateLanguage(): string {
    // Check Google Translate cookie
    const cookies = document.cookie.split(";");
    for (let cookie of cookies) {
      const [name, value] = cookie.trim().split("=");
      if (name === "googtrans") {
        // Format: /en/es (from English to Spanish)
        const parts = value.split("/");
        if (parts.length >= 3) {
          return parts[2]; // Return target language
        }
      }
    }
    return null;
  }

  handleLanguageSelection(): void {
    // Get the selected language
    const selectedLang = this.getCurrentTranslateLanguage();

    if (selectedLang && selectedLang !== "en") {
      // Language has been selected, trigger translation
      this.triggerTranslation(selectedLang);
    }
  }

  applyTranslation(targetLanguage: string): void {
    // Apply translation by setting the Google Translate cookie and hash
    // Google Translate will automatically detect these and translate the page
    try {
      const langCode = targetLanguage === "zh-CN" ? "zh-CN" : targetLanguage;

      // Set the cookie that Google Translate uses
      const cookieValue = `/en/${langCode}`;
      document.cookie = `googtrans=${cookieValue}; path=/; max-age=31536000`; // 1 year

      // Set the URL hash - Google Translate monitors this and translates automatically
      const hashValue = `googtrans(en|${langCode})`;
      if (window.location.hash !== `#${hashValue}`) {
        window.location.hash = hashValue;
      }

      // Google Translate should automatically detect the hash and translate
      // If it doesn't trigger automatically, use the API method
      setTimeout(() => {
        this.triggerGoogleTranslateAPI(targetLanguage);
      }, 300);
    } catch (e) {
      console.log("Translation apply error:", e);
    }
  }

  triggerGoogleTranslateAPI(targetLanguage: string): void {
    // Google Translate automatically translates when language is selected
    // We just need to ensure the cookie and hash are set correctly
    try {
      const langCode = targetLanguage === "zh-CN" ? "zh-CN" : targetLanguage;

      // Set cookie (Google Translate reads this)
      document.cookie = `googtrans=/en/${langCode}; path=/; max-age=31536000`;

      // Update hash (Google Translate uses this to trigger translation)
      const hashValue = `googtrans(en|${langCode})`;
      if (window.location.hash !== `#${hashValue}`) {
        window.location.hash = hashValue;
      }

      // Google Translate should automatically detect the hash change and translate
      // On desktop, use triggerTranslationWithoutReload instead of reloading
      if (this.isMobileView) {
        // Mobile: check if translation is active and reload if needed
      setTimeout(() => {
        const currentHash = window.location.hash;
        if (currentHash.includes("googtrans")) {
          // Check if translation is active
          const isTranslated =
            document.body.classList.contains("translated-ltr") ||
            document.body.classList.contains("translated-rtl");

          if (!isTranslated) {
              // Translation didn't apply automatically, reload page (mobile only)
            window.location.reload();
          }
        }
      }, 500);
      } else {
        // Desktop: trigger translation without reload
        this.triggerTranslationWithoutReload(targetLanguage);
        setTimeout(() => {
          this.moveBannerToFooter();
          this.moveTranslateIframeToFooter();
        }, 500);
      }
    } catch (e) {
      console.log("Google Translate API trigger error:", e);
    }
  }

  triggerTranslation(targetLanguage: string): void {
    // Call applyTranslation which handles the actual translation
    this.applyTranslation(targetLanguage);
  }

  ensureTranslationActive(): void {
    // Ensure the page is actually being translated
    const body = document.body;
    if (body) {
      // Check if Google Translate has added its classes
      const isTranslated =
        body.classList.contains("translated-ltr") ||
        body.classList.contains("translated-rtl") ||
        document.querySelector(".goog-te-banner-frame");

      if (!isTranslated) {
        // Translation might not be active, try to trigger it
        const selectedLang = this.getCurrentTranslateLanguage();
        if (selectedLang) {
          this.triggerTranslation(selectedLang);
        }
      }
    }
  }

  handleMobileTranslateChange = (event: Event): void => {
    const target = event.target as HTMLSelectElement;
    const selectedLang = target.value;
    if (selectedLang && selectedLang !== "en") {
      console.log("Mobile translate language selected:", selectedLang);
      // Immediately apply translation on mobile
      this.ensureTranslationApplied(selectedLang);
    }
  };

  handleDesktopTranslateChange = (event: Event): void => {
    const target = event.target as HTMLSelectElement;
    const selectedLang = target.value;
    if (selectedLang && selectedLang !== "" && selectedLang !== "en") {
      console.log("Desktop translate language selected:", selectedLang);
      // Immediately apply translation on desktop (same as mobile)
      this.ensureTranslationApplied(selectedLang);
    } else if (selectedLang === "" || selectedLang === "en") {
      // Reset to English
      this.selectedLanguage = null;
      this.selectedLanguageName = null;
      document.cookie = `googtrans=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT`;
      window.location.hash = "";
      this.cdr.detectChanges();
    }
  };

  ensureTranslationApplied(targetLanguage: string): void {
    // Ensure translation is actually applied when language is selected
    const langCode = targetLanguage === "zh-CN" ? "zh-CN" : targetLanguage;

    // Set cookie to persist the language selection
    document.cookie = `googtrans=/en/${langCode}; path=/; max-age=31536000`;

    // Update selected language display
    this.selectedLanguage = langCode;
    this.selectedLanguageName = this.getLanguageName(langCode);
    this.cdr.detectChanges();

    // Ensure hash is set - this is critical for Google Translate
    const hashValue = `googtrans(en|${langCode})`;
    const currentHash = window.location.hash;

    if (!currentHash.includes(hashValue)) {
      // Set hash - this triggers Google Translate
      window.location.hash = hashValue;
    }

    // Close the translate dropdown after selection
    setTimeout(() => {
      this.showMobileTranslate = false;
      this.cdr.detectChanges();
    }, 300);

    // For both mobile and desktop, trigger translation without reload
      // Use Google Translate API to translate without reload
      setTimeout(() => {
        this.triggerTranslationWithoutReload(langCode);
      // Ensure banner and iframe move to footer after translation (for both mobile and desktop)
        setTimeout(() => {
          this.moveBannerToFooter();
          this.moveTranslateIframeToFooter();
        // On both desktop and mobile, keep forcing translate iframes hidden
        // (Google may re-inject them)
        this.hideDesktopTranslateIframes();
        const stopAt = Date.now() + 8000;
        const interval = this.trackPerformanceInterval(() => {
          this.hideDesktopTranslateIframes();
          if (Date.now() > stopAt) {
            clearInterval(interval);
          }
        }, 800);
        }, 500);
      }, 200);
  }

  triggerTranslationWithoutReload(langCode: string): void {
    // Trigger Google Translate without page reload
    try {
      // Set the cookie first (Google Translate reads this)
      document.cookie = `googtrans=/en/${langCode}; path=/; max-age=31536000`;

      // Set hash to trigger translation
      // Google Translate listens to hash changes to trigger translation
      const hashValue = `googtrans(en|${langCode})`;
      const currentHash = window.location.hash;
      
      // Force hash change to trigger hashchange event
      if (currentHash === `#${hashValue}`) {
        // Hash is already set, force a change by clearing and resetting
        window.location.hash = "";
        setTimeout(() => {
          window.location.hash = hashValue;
        }, 10);
      } else {
        // Set the hash directly
        window.location.hash = hashValue;
      }
      
      // Also manually dispatch hashchange event for better compatibility
      setTimeout(() => {
        try {
          // Try modern HashChangeEvent constructor
          if (typeof HashChangeEvent !== "undefined") {
            window.dispatchEvent(new HashChangeEvent("hashchange", {
              oldURL: window.location.href.split("#")[0] + (currentHash || ""),
              newURL: window.location.href.split("#")[0] + "#" + hashValue
            }));
          } else {
            // Fallback: create a simple event
            const event = document.createEvent("HashChangeEvent");
            event.initEvent("hashchange", false, false);
            window.dispatchEvent(event);
          }
        } catch (e) {
          // If event creation fails, just rely on the hash change itself
          console.log("HashChangeEvent dispatch error:", e);
        }
      }, 50);

      // Wait for Google Translate to be ready and then trigger translation
      const waitForGoogleTranslate = (maxAttempts = 10, attempt = 0) => {
        if (attempt >= maxAttempts) {
          console.log("Google Translate not ready after max attempts");
          return;
        }

        // Check if Google Translate is loaded
        const isGoogleTranslateReady =
          (window as any).google &&
          (window as any).google.translate &&
          document.querySelector(".goog-te-combo");

        if (isGoogleTranslateReady || attempt === 0) {
          // Find ALL translate combo elements (there might be multiple)
          const translateElements = document.querySelectorAll(
            ".goog-te-combo"
          ) as NodeListOf<HTMLSelectElement>;

          if (translateElements.length > 0) {
          // Trigger change on all combo elements
          translateElements.forEach((element) => {
            if (element) {
              element.value = langCode;
              // Create and dispatch a proper change event
              const changeEvent = new Event("change", {
                bubbles: true,
                cancelable: true,
              });
              element.dispatchEvent(changeEvent);
              
              // Also try input event
              const inputEvent = new Event("input", {
                bubbles: true,
                cancelable: true,
              });
              element.dispatchEvent(inputEvent);
            }
          });
        }

        // Also try to trigger translation via Google Translate API if available
        if (
          (window as any).google &&
          (window as any).google.translate &&
          (window as any).google.translate.TranslateElement
        ) {
          // Try to find and trigger the translate function directly
          try {
            // Force re-translation by manipulating the page
            const body = document.body;
            if (body) {
              // Remove existing translation classes
              body.classList.remove("translated-ltr", "translated-rtl");
              
              // Set hash again to force Google Translate to re-process
              window.location.hash = hashValue;
              
              // Try to trigger translation via Google Translate iframe
              // Google Translate uses an iframe to translate pages
              const translateIframe = document.querySelector(
                "iframe.skiptranslate"
              ) as HTMLIFrameElement;
              if (translateIframe && translateIframe.contentWindow) {
                try {
                  // Try to reload the iframe with new language
                  const iframeSrc = translateIframe.src;
                  if (iframeSrc) {
                    // Update iframe src to trigger re-translation
                    translateIframe.src = iframeSrc.split("?")[0] + `?langpair=en|${langCode}`;
                  }
                } catch (iframeError) {
                  // Cross-origin restrictions might prevent iframe access
                  console.log("Iframe access restricted:", iframeError);
                }
              }

              // Wait a bit more and check if translation was applied
              setTimeout(() => {
                // Check if translation classes were added
                const isTranslated =
                  body.classList.contains("translated-ltr") ||
                  body.classList.contains("translated-rtl");

                if (!isTranslated) {
                  // If still not translated, try one more time with a click simulation
                  translateElements.forEach((element) => {
                    if (element) {
                      // Simulate a full user interaction
                      element.focus();
                      element.value = langCode;
                      const changeEvent = new Event("change", {
                        bubbles: true,
                        cancelable: true,
                      });
                      element.dispatchEvent(changeEvent);
                      element.blur();
                    }
                  });

                  // Last resort: try to manually trigger Google Translate's translation
                  // by creating a temporary link and clicking it
                  setTimeout(() => {
                    const tempLink = document.createElement("a");
                    tempLink.href = `#googtrans(en|${langCode})`;
                    tempLink.style.display = "none";
                    document.body.appendChild(tempLink);
                    tempLink.click();
                    setTimeout(() => {
                      document.body.removeChild(tempLink);
                    }, 100);
                  }, 200);
                }
              }, 500);
            }
          } catch (apiError) {
            console.log("Google Translate API trigger error:", apiError);
          }
          }
        }

        if (!isGoogleTranslateReady && attempt < maxAttempts - 1) {
          // Google Translate not ready yet, try again
          setTimeout(() => {
            waitForGoogleTranslate(maxAttempts, attempt + 1);
          }, 200);
        }
      };

      // Start waiting for Google Translate
      waitForGoogleTranslate();
    } catch (e) {
      console.log("Translation trigger error:", e);
    }
  }

  getLanguageName(code: string): string {
    const languageNames: { [key: string]: string } = {
      en: "English",
      es: "Spanish",
      fr: "French",
      de: "German",
      it: "Italian",
      pt: "Portuguese",
      ru: "Russian",
      ja: "Japanese",
      ko: "Korean",
      "zh-CN": "Chinese",
      ar: "Arabic",
      hi: "Hindi",
      tr: "Turkish",
    };
    return languageNames[code] || code.toUpperCase();
  }

  /* Reset / turn off Google translation (desktop + mobile) */
  resetTranslation(): void {
    const expiry = "expires=Thu, 01 Jan 1970 00:00:00 GMT";
    const path = "path=/";

    // Clear Google Translate cookie - path only (works for same-origin cookie)
    document.cookie = `googtrans=; ${expiry}; ${path}`;

    // On production, the cookie may be set with domain (e.g. .flowchest.com).
    // Clear with domain so it is removed after reload.
    const hostname = typeof window !== "undefined" ? window.location.hostname : "";
    if (hostname && hostname !== "localhost" && !hostname.endsWith(".localhost")) {
      document.cookie = `googtrans=; ${expiry}; ${path}; domain=${hostname}`;
      const parentDomain = hostname.indexOf(".") > -1 ? "." + hostname.split(".").slice(-2).join(".") : "." + hostname;
      document.cookie = `googtrans=; ${expiry}; ${path}; domain=${parentDomain}`;
    }

    // Clear hash used by Google Translate (prevents re-applying after reload)
    if (window.location.hash && window.location.hash.indexOf("googtrans(") !== -1) {
      history.replaceState(
        null,
        "",
        window.location.pathname + window.location.search
      );
    }

    // Reset selection state
    this.selectedLanguage = null;
    this.selectedLanguageName = null;

    // Reload the page to restore original language cleanly
    window.location.reload();
  }

  showToast() {
    this.toastr.success("Successfully Signed In", "title");
  }

  showToastForLogout() {
    this.toastr.success("Logout Successful");
  }

  Logout() {
    this.data.changeMessagebool(false);
    this.tokenService.clearAuthStorage();
    this.isUserLoggedIn = false;
    this.userData = null;
    this.eventEmitterService.setLoggedInUserProperty(false);
    this.showToastForLogout();
    this.route.navigateByUrl("/login");
  }

  fnturnOnNightMode() {
    this.toggleThemeMode();
  }

  get isDarkThemeActive(): boolean {
    return this.selectedThemeMode === "dark";
  }

  toggleThemeMode(): void {
    const nextTheme = this.themePreferenceService.toggleTheme();
    this.persistThemeMode(nextTheme);
  }

  private initializeThemeMode(): void {
    this.themePreferenceService.initializeFromStorage();
  }

  private applyThemeMode(theme: ThemeMode): void {
    this.selectedThemeMode = theme === "dark" ? "dark" : "light";
    this.turnOnNightMode =
      this.selectedThemeMode === "dark"
        ? "Turn Off Night Mode"
        : "Turn On Night Mode";
  }

  private persistThemeMode(theme: "light" | "dark"): void {
    if (this.userData?.emailAddress) {
      this.userserviceService
        .UpdateThemeSettingsForCustomerProfileDetails({
          emailAddress: this.userData.emailAddress,
          selectedTheme: theme,
        })
        .subscribe({
          next: () => {
            if (this.userData) {
              this.userData.selectedTheme = theme;
              localStorage.setItem("LoggedInUser", JSON.stringify(this.userData));
            }
          },
          error: () => {
            // Keep local theme even if API save fails.
          },
        });
    }
  }

  async ngOnInit() {
    // Initialize debounced search stream
    this.searchInputSubject
      .pipe(
        debounceTime(500),
        distinctUntilChanged()
      )
      .subscribe((value: string) => {
        const trimmed = (value || "").trim();
        // In Items mode, we don't auto-search on every keystroke because the user
        // is building a multi-item query via chips.
        if (this.isItemsSearchMode) {
          return;
        }
        if (trimmed.length > 0) {
          // Trigger existing search behaviour after user stops typing
          this.globalSearch();
        }
      });
    // if (window.location.href.includes("user-dashboard")) {
    //   this.isuserdashboard = true;
    // } else {
    //   this.isuserdashboard = false;
    // }

    this.yesterday.setDate(this.yesterday.getDate() - 1);
    this.thisWeekStart.setDate(
      this.thisWeekStart.getDate() - this.thisWeekStart.getDay()
    );

    // Initialize mobile view check
    this.onResize(0);
    // Ensure sidebar is closed on mobile by default
    if (this.isMobileView) {
      this.sidebarCollapsed = true;
    }

    // Check for existing selected language
    const currentLang = this.getCurrentTranslateLanguage();
    if (currentLang) {
      this.selectedLanguage = currentLang;
      this.selectedLanguageName = this.getLanguageName(currentLang);
    }

    // Close sidebar if on view flow page (guide routes)
    const currentUrl = this.router.url || window.location.pathname;
    if (
      currentUrl.startsWith("/guide/") ||
      currentUrl === "/view" ||
      currentUrl.startsWith("/view-guide-pack") ||
      currentUrl.startsWith("/create-guide")
    ) {
      this.sidebarCollapsed = true;
    }
    
    // Handle initial auth modal routes
    if (currentUrl === '/login' || currentUrl.startsWith('/login')) {
      this.openAuthModalFromRoute('login');
    } else if (currentUrl === '/registration' || currentUrl.startsWith('/registration')) {
      this.openAuthModalFromRoute('registration');
    } else if (currentUrl === '/activateaccount' || currentUrl.startsWith('/activateaccount')) {
      this.openAuthModalFromRoute('activateaccount');
    } else if ((currentUrl.includes('/forget-password') || currentUrl.includes('/forgot-password')) && !currentUrl.includes('/user-settings/forget-password')) {
      this.openAuthModalFromRoute('forget-password');
    } else if (currentUrl.includes('/change-password') && !currentUrl.includes('/user-settings/')) {
      this.openAuthModalFromRoute('change-password');
    }

    this.repoUrl = "http://www.Flowchest.com"; //urle shared
    this.homeColor = this.brandAccentImportant();
    this.userData = this.getStoredLoggedInUser();
    this.restoreAuthSessionFromStorage();

    // Load search history
    this.loadSearchHistory();

    console.log(this.userData);
    console.log(this.isUserLoggedIn);
    console.log(this.premissionToActions);
    if (this.userData != null) {
      //this.eventEmitterService.setUserProfileCreateIconClickedEvent("search");
      this.userDisplayName = this.userData.firstName;
      this.userDisplayEmail = this.userData.emailAddress;
      this.email = this.userData.emailAddress;
      this.phone = this.userData.phoneNumber;
      this.info = this.userData.info;
      this.website = this.userData.website;
      this.uname = this.userData.userName;
      this.name = this.userData.firstName;
      this.isAdmin = isSiteAdminUser(this.userData);
      this.applyProfilePictureFromStoredUser();
      if (this.tokenService.hasUsableToken()) {
        this.getProfileUser();
        this.refreshPermissionsFromServer(this.userData);
        this.subscriptionUsageAlertService.checkAndNotify();
      }
      await this.checkPermissions();
      this.loadOrgContext();
    }

    if (this.userData != null && this.tokenService.hasUsableToken()) {
      this.getnotification();
    }

    // Always listen (not only when first loaded logged-out) so re-login after
    // a session expiry also resolves the account type.
    this.data.currentMessagebool.subscribe((res) => {
      this.isLogin = res;
      if (res) {
        this.loadOrgContext();
      } else {
        this.clearOrgContextUi();
      }
    });

    this.initialize();

    // Sync header search with real URL query params (not only ActivatedRoute on this shell).
    // On some navigations / platforms, AppComponent's ActivatedRoute queryParams can lag the
    // Router URL; Items tab uses ?category=Items and the header must match or Items UX is missing.
    // Accept params directly from each source so we always use the authoritative
    // values for that emission rather than re-reading this.router.url, which may
    // lag behind when activateRouter.queryParams fires mid-navigation.
    const syncHeaderSearchFromParams = (params: Record<string, any>) => {
      const rawQ = params["q"];
      const q =
        (Array.isArray(rawQ) ? rawQ[0] : rawQ)?.toString().trim() || "";

      this.currentSearchCategory = (params["category"] || "All").toString();
      this.syncCategorySelectorFromCategory(this.currentSearchCategory);

      // Keep activeHomeCategory in sync so both properties agree.
      const catMap: Record<string, 'Flows' | 'Users' | 'Bundles' | 'Items'> = {
        Users: 'Users', Bundles: 'Bundles', Items: 'Items',
      };
      this.activeHomeCategory = catMap[this.currentSearchCategory] ?? 'Flows';

      // Keep flowSearchField in sync with the Items category so the pill label
      // and selected state are correct even after a page refresh or direct URL.
      if (this.currentSearchCategory.toLowerCase() === 'items') {
        this.flowSearchField = 'Items';
      } else if (this.currentSearchCategory === 'All') {
        // Sync from the searchField query param when on the Flows tab.
        const sf = (params['searchField'] || '').toString();
        if (sf === 'Title' || sf === 'UniqueCode') {
          this.flowSearchField = sf;
        } else if (!sf) {
          this.flowSearchField = 'All';
        }
      }

      // In Items mode, `q` is represented by header chips only — do not mirror it into
      // the text field (would undo clearing after Enter and duplicate chip text).
      if (q) {
        if (!this.isItemsSearchMode) {
          this.searchInput = q;
        }
      }
      // Hydrate item chips from `q` when in Items mode (comma-separated).
      if (this.isItemsSearchMode) {
        this.selectedItemSearchChips = q
          .split(",")
          .map((s) => s.trim())
          .filter((s) => !!s);
      } else {
        this.selectedItemSearchChips = [];
        this.itemSearchSuggestions = [];
      }

    };

    merge(
      // Initial load: read from the current (already-complete) URL.
      of(this.router.parseUrl(this.router.url).queryParams),
      // Tab/query-param changes: ActivatedRoute emits the NEW params for the
      // in-progress navigation, so use them directly instead of re-reading
      // router.url (which may still reflect the previous URL at this point).
      this.activateRouter.queryParams,
      // NavigationEnd: navigation fully committed — re-read from router.url to
      // catch any edge case where ActivatedRoute emission was missed.
      this.router.events.pipe(
        filter((e): e is NavigationEnd => e instanceof NavigationEnd),
        map(() => this.router.parseUrl(this.router.url).queryParams)
      )
    ).subscribe((params) => syncHeaderSearchFromParams(params));

    // Item library suggestions (header) — active in all search modes
    this.itemSearchInput$
      .pipe(
        debounceTime(300),
        distinctUntilChanged(),
        switchMap((term: string) => {
          const trimmed = (term || "").trim();
          if (trimmed.length < 2) {
            return of([]);
          }
          const userEmail = this.userData?.emailAddress || "";
          return this.itemLibraryService
            .searchItemLibraries({ itemName: trimmed, userEmail })
            .pipe(catchError(() => of([])));
        })
      )
      .subscribe((results: ItemLibraryModel[]) => {
        const seen = new Set<string>();
        this.itemSearchSuggestions = (results || []).filter((r) => {
          const name = (r?.itemName || "").trim();
          if (!name) return false;
          const key = name.toLowerCase();
          if (seen.has(key)) return false;
          seen.add(key);
          return true;
        });
        // Show dropdown as soon as suggestions arrive (even in non-Items mode)
        if (this.itemSearchSuggestions.length > 0) {
          this.showSearchHistory = true;
        }
      });

    // @-mention user search — fires when user types @<text> in the header search
    this.userMentionInput$
      .pipe(
        debounceTime(300),
        distinctUntilChanged(),
        switchMap((term: string) => {
          if (term.length < 1) {
            return of([]);
          }
          const query = new FlowQueryModel({ searchString: term, userEmail: this.userData?.emailAddress || '' });
          return this.userserviceService.searchInUsers(query).pipe(catchError(() => of({ allUsers: [] })));
        })
      )
      .subscribe((data: any) => {
        const users: any[] = (data?.allUsers || []).slice(0, 5);
        this.userMentionSuggestions = users;
        if (users.length > 0) {
          this.showSearchHistory = true;
        }
      });

    this.filteredOptions = this.myControl.valueChanges.pipe(
      startWith(""),
      map((value) => this._filter(value))
    );

    console.log(this.userDisplayName);
  }

  checkPermissions() {
    // Always refresh from localStorage so changes after login/role updates are picked up
    const storedPermissions = localStorage.getItem("PremissionToActions");
    this.premissionToActions = storedPermissions
      ? JSON.parse(storedPermissions)
      : {};

    // Derive the effective role name without changing it
    const effectiveRole = this.permissionsService.resolveEffectiveRole(
      this.userData
    );

    // Super Admin should always have full access regardless of stored permissions
    if (effectiveRole === "Super Admin") {
      this.canViewNotification = true;
      this.canCreateFlowOrBundle = true;
      this.canViewUserDashBoard = true;
      this.canAccessCreatorChrome = true;
      this.canAccessOrgAdmin = true;
      this.canAccessOrgSetup = true;
      return;
    }

    // If we have no permission map, block everything by default
    if (!this.premissionToActions) {
      this.canViewNotification = false;
      this.canCreateFlowOrBundle = false;
      this.canViewUserDashBoard = false;
      this.canAccessCreatorChrome = false;
      this.canAccessOrgAdmin = false;
      this.canAccessOrgSetup = false;
      return;
    }

    // Notification View is allowed for every logged-in role (including "User").
    this.canViewNotification =
      !!this.premissionToActions["Notification"]?.["View"] || !!effectiveRole;

    // Organization account type → org access-role feature matrix for the
    // user's assigned role. Public account type → platform permission map.
    const orgLoaded = this.orgContextService.snapshot.loaded;
    if (orgLoaded && this.orgContextService.isOrganizationMode()) {
      const canCreate = this.orgContextService.canCreateOrgContent();
      const canApprove = this.orgContextService.canApproveContent();
      this.canCreateFlowOrBundle = canCreate;
      this.canViewUserDashBoard = canCreate || canApprove;
      this.canAccessCreatorChrome = this.canViewUserDashBoard;
      this.showOrgJoinDiscover = false;
    } else {
      this.canCreateFlowOrBundle =
        this.permissionsService.hasFlowBundleCreateEditAccess(this.userData);
      this.canViewUserDashBoard =
        !!this.premissionToActions["Dashboard"]?.["View"];
      this.canAccessCreatorChrome =
        this.canCreateFlowOrBundle || this.canViewUserDashBoard;
      this.showOrgJoinDiscover = false;
    }
    this.canAccessOrgAdmin = this.orgContextService.canAccessOrgAdminConsole();
    this.canAccessOrgSetup = this.orgContextService.canAccessOrgSetup(
      this.userData
    );
  }

  private refreshPermissionsFromServer(userData?: any): void {
    this.permissionsService.refresh(userData || this.userData).subscribe();
  }

  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();
    return this.options.filter((option) =>
      option.toLowerCase().includes(filterValue)
    );
  }

  homePage() {
    this.isuserdashboard = false;
    this.router.navigate(["/"]);
    this.homeColor = this.brandAccent;
    this.searchColor = this.brandAccentImportant();
    this.emoji_objectsColor = "#212427";
    this.notificationsColor = "#212427";
    this.add_circle_outlineColor = "#212427";
    this.account_circleColor = "#212427";
    this.profileColor = "#212427";
    this.personColor = "#212427";
  }

  // App layout methods
  /** Shows the full label as a hover tooltip when a sidebar label is truncated or hidden. */
  onSidebarItemHover(event: MouseEvent): void {
    const target = event.target as HTMLElement | null;
    const item = target?.closest?.(
      ".sidebar-item, .sidebar-account-option"
    ) as HTMLElement | null;
    if (!item) return;

    const labels = Array.from(
      item.querySelectorAll<HTMLElement>(
        ".sidebar-account-option-name, .sidebar-account-option-role, :scope > span"
      )
    ).filter((el) => !el.classList.contains("sidebar-account-option-text"));
    const text = labels
      .map((el) => (el.textContent || "").trim())
      .filter(Boolean)
      .join(" · ");
    if (!text) return;

    const truncated = labels.some(
      (el) => el.offsetWidth === 0 || el.scrollWidth > el.clientWidth + 1
    );
    if (truncated || this.sidebarCollapsed) {
      if (item.title !== text) item.title = text;
    } else if (item.title) {
      item.removeAttribute("title");
    }
  }

  toggleSidebar(): void {
    this.sidebarCollapsed = !this.sidebarCollapsed;
  }

  handleSearchInputChange(value: string): void {
    // Items mode: comma commits the preceding text as a chip (iOS-friendly alternative
    // to Enter/Search, which often blurs or submits the field on Safari/Chrome).
    if (this.isItemsSearchMode && value && value.endsWith(",")) {
      const tagText = value.slice(0, -1).trim();
      if (tagText) {
        this.addHeaderItemChip(tagText);
        return;
      }
    }

    const trimmedValue = (value || "").trim();
    
    // Update filtered search history as user types
    this.updateFilteredSearchHistory();

    // @-mention detection: if input starts with @, search users with the text after @
    if (trimmedValue.startsWith('@')) {
      const mentionText = trimmedValue.slice(1); // strip the leading @
      this.userMentionInput$.next(mentionText);
    } else {
      // Clear user mention suggestions when @ prefix is removed
      if (this.userMentionSuggestions.length > 0) {
        this.userMentionSuggestions = [];
      }
      this.userMentionInput$.next('');
    }

    // Emit value into debounced search stream
    this.searchInputSubject.next(value || "");
    
    // Always emit to the item suggestion stream so suggestions appear in every mode.
    this.itemSearchInput$.next(value || "");

    // In Items mode keep dropdown open even without existing history
    if (this.isItemsSearchMode) {
      this.showSearchHistory = true;
    }

    // Always show history dropdown when user is typing (if there's history)
    // If input is empty, show all history; if input has text, show filtered history
    if (this.searchHistory.length > 0) {
      this.showSearchHistory = true;
    }
    
    // If input is cleared and there's no history, hide dropdown
    if (trimmedValue.length === 0 && this.searchHistory.length === 0 && !this.isItemsSearchMode) {
      this.showSearchHistory = false;
      return;
    }
    
    // If there's input, keep showing dropdown (already set above)
    if (trimmedValue.length > 0) {
      return;
    }

    const hasSearchQuery =
      this.activateRouter.snapshot.queryParamMap.has("q") ||
      this.router.url.includes("?q=");
    if (!hasSearchQuery) {
      return;
    }

    this.router.navigate([], {
      relativeTo: this.activateRouter,
      queryParams: { q: null },
      queryParamsHandling: "merge",
      replaceUrl: true,
    });
  }
  
  // Search History Methods
  loadSearchHistory(): void {
    this.searchHistory = this.searchHistoryService.getHistory();
    this.updateFilteredSearchHistory();
  }
  
  updateFilteredSearchHistory(): void {
    this.filteredSearchHistory = this.searchHistoryService.getFilteredHistory(this.searchInput);
  }
  
  onSearchInputFocus(): void {
    this.loadSearchHistory();
    // Show dropdown if there is history, item suggestions, or we are in Items mode
    if (this.isItemsSearchMode || this.searchHistory.length > 0 || this.itemSearchSuggestions.length > 0) {
      this.showSearchHistory = true;
    }
    this.selectedHistoryIndex = -1;
  }
  
  onSearchInputBlur(event: FocusEvent): void {
    // Delay hiding to allow click events on history items to fire
    setTimeout(() => {
      // Check if focus moved to search history dropdown or remove button
      const relatedTarget = event.relatedTarget as HTMLElement;
      const activeElement = document.activeElement as HTMLElement;
      const isClickingHistory = relatedTarget?.closest('.search-history-dropdown') || 
                                 activeElement?.closest('.search-history-dropdown');
      
      if (!isClickingHistory) {
        this.hideSearchHistory();
      }
    }, 200);
  }

  /** Desktop search input blur — commits pending chip text on iOS then falls back to normal blur. */
  onDesktopSearchInputBlur(event: FocusEvent): void {
    if (this.isItemsSearchMode) {
      this.onItemsChipInputBlur();
    } else {
      this.onSearchInputBlur(event);
    }
  }

  /** Mobile search input blur — same logic as desktop blur. */
  onMobileSearchInputBlur(event: FocusEvent): void {
    if (this.isItemsSearchMode) {
      this.onItemsChipInputBlur();
    } else {
      this.onSearchInputBlur(event);
    }
  }
  
  hideSearchHistory(): void {
    this.showSearchHistory = false;
    this.selectedHistoryIndex = -1;
  }
  
  selectSearchHistoryItem(item: string): void {
    // In Items mode, treat selecting a past search as restoring the full chip set.
    if (this.isItemsSearchMode) {
      const q = (item || "").toString();
      this.selectedItemSearchChips = q
        .split(",")
        .map((s) => s.trim())
        .filter((s) => !!s);
      this.searchInput = "";
      this.hideSearchHistory();
      this.performHeaderItemsSearch();
      return;
    }

    this.searchInput = item;
    this.hideSearchHistory();
    this.globalSearch();
  }
  
  removeSearchHistoryItem(event: Event, item: string): void {
    event.stopPropagation();
    this.searchHistoryService.removeFromHistory(item);
    this.loadSearchHistory();
  }
  
  clearAllSearchHistory(): void {
    this.searchHistoryService.clearHistory();
    this.loadSearchHistory();
  }
  
  onSearchInputKeyDown(event: KeyboardEvent): void {
    // Items mode: handle Enter/Go at keydown so iOS does not submit the field or
    // dismiss the keyboard before the chip is committed (keyup.enter is too late).
    if (this.isItemsSearchMode && (event.key === "Enter" || event.keyCode === 13)) {
      event.preventDefault();
      event.stopPropagation();
      const trimmed = (this.searchInput || "").trim();
      if (trimmed) {
        this.addHeaderItemChip(trimmed);
      } else {
        this.performHeaderItemsSearch();
      }
      return;
    }

    if (!this.showSearchHistory || this.filteredSearchHistory.length === 0) {
      return;
    }
    
    switch (event.key) {
      case 'ArrowDown':
        event.preventDefault();
        this.selectedHistoryIndex = Math.min(
          this.selectedHistoryIndex + 1,
          this.filteredSearchHistory.length - 1
        );
        break;
      case 'ArrowUp':
        event.preventDefault();
        this.selectedHistoryIndex = Math.max(this.selectedHistoryIndex - 1, -1);
        break;
      case 'Enter':
        if (this.selectedHistoryIndex >= 0 && this.selectedHistoryIndex < this.filteredSearchHistory.length) {
          event.preventDefault();
          this.selectSearchHistoryItem(this.filteredSearchHistory[this.selectedHistoryIndex]);
        }
        break;
      case 'Escape':
        this.hideSearchHistory();
        break;
    }
  }

  onSearchEnter(event: KeyboardEvent): void {
    if (this.isItemsSearchMode) {
      // Already handled in onSearchInputKeyDown; prevent duplicate chip commits.
      event.preventDefault();
      return;
    }
    this.globalSearch();
  }

  /** Native `search` event on type=search inputs — skip in Items mode (use text inputs there). */
  onSearchInputNativeSearch(event: Event): void {
    if (this.isItemsSearchMode) {
      event.preventDefault();
      return;
    }
    this.globalSearch();
  }

  private touchStartX: number = 0;
  private touchStartY: number = 0;
  private touchStartTime: number = 0;
  private touchTracking: boolean = false;
  private readonly swipeDistanceThreshold = 60;
  private readonly swipeTimeThreshold = 600;
  private readonly swipeVerticalAllowance = 80;

  @HostListener("touchstart", ["$event"])
  onTouchStart(event: TouchEvent): void {
    if (!this.showMenu || event.touches.length !== 1) {
      return;
    }
    const touch = event.touches[0];
    this.touchTracking = true;
    this.touchStartX = touch.clientX;
    this.touchStartY = touch.clientY;
    this.touchStartTime = event.timeStamp;
  }

  @HostListener("touchend", ["$event"])
  onTouchEnd(event: TouchEvent): void {
    if (!this.touchTracking || event.changedTouches.length !== 1) {
      return;
    }

    const touch = event.changedTouches[0];
    const deltaX = touch.clientX - this.touchStartX;
    const deltaY = touch.clientY - this.touchStartY;
    const elapsed = event.timeStamp - this.touchStartTime;
    this.touchTracking = false;

    if (
      elapsed > this.swipeTimeThreshold ||
      Math.abs(deltaX) < this.swipeDistanceThreshold ||
      Math.abs(deltaY) > this.swipeVerticalAllowance
    ) {
      return;
    }

    // Swipe left closes sidebar, swipe right opens (mobile/tablet only)
    if (deltaX < 0 && !this.sidebarCollapsed) {
      this.sidebarCollapsed = true;
    } else if (deltaX > 0 && this.sidebarCollapsed && this.isMobileView) {
      this.sidebarCollapsed = false;
    }
  }

  globalSearch(): void {
    const trimmed = (this.searchInput || "").trim();

    if (this.isItemsSearchMode) {
      // In Items mode, Enter/Search adds the current text as a chip (if present),
      // then searches using the chip list.
      if (trimmed) {
        this.addHeaderItemChip(trimmed);
      } else {
        this.performHeaderItemsSearch();
      }
      return;
    }

    // @-mention: navigate to Users search with the text after @
    if (trimmed.startsWith('@')) {
      const mentionText = trimmed.slice(1).trim();
      if (mentionText) {
        this.searchHistoryService.addToHistory(trimmed);
        this.hideSearchHistory();
        this.userMentionSuggestions = [];
        this.router.navigate(['/'], {
          queryParams: { q: mentionText, category: 'Users' },
          queryParamsHandling: 'merge',
        });
      }
      return;
    }

    if (trimmed !== "") {
      // Save to search history
      this.searchHistoryService.addToHistory(trimmed);
      this.hideSearchHistory();

      // Navigate to search page with the search input
      this.router.navigate(["/"], {
        queryParams: { q: trimmed },
        queryParamsHandling: "merge",
      });
    }
  }

  selectUserMentionSuggestion(user: any): void {
    this.hideSearchHistory();
    this.userMentionSuggestions = [];
    this.searchInput = '';
    // Navigate to Users search filtered by the selected user's userName
    this.router.navigate(['/'], {
      queryParams: { q: user.userName, category: 'Users' },
      queryParamsHandling: 'merge',
    });
  }

  addHeaderItemChipFromSuggestion(item: ItemLibraryModel) {
    const name = (item?.itemName || "").trim();
    if (!name) return;
    this.addHeaderItemChip(name);
  }

  removeHeaderItemChip(index: number) {
    if (index < 0 || index >= this.selectedItemSearchChips.length) return;
    // Replace with a new array so iOS/Safari change detection sees the update.
    this.selectedItemSearchChips = this.selectedItemSearchChips.filter((_, i) => i !== index);
    this.cdr.detectChanges();
    this.performHeaderItemsSearch();
  }

  clearHeaderItemChips() {
    this.selectedItemSearchChips = [];
    this.itemSearchSuggestions = [];
    this.searchInput = "";
    this.cdr.detectChanges();
    // Clear q but keep category
    this.router.navigate([], {
      relativeTo: this.activateRouter,
      queryParams: { q: null },
      queryParamsHandling: "merge",
      replaceUrl: true,
    });
  }

  private addHeaderItemChip(name: string) {
    const normalized = (name || "").trim();
    if (!normalized) return;
    const exists = this.selectedItemSearchChips.some(
      (c) => c.toLowerCase() === normalized.toLowerCase()
    );
    if (!exists) {
      // Use a new array reference so Angular's change detection always picks up
      // the mutation (critical on iOS/Safari where touchend may not trigger a CD cycle).
      this.selectedItemSearchChips = [...this.selectedItemSearchChips, normalized];
    }
    // Clear the input so user can add the next item quickly.
    this.searchInput = "";
    this.itemSearchSuggestions = [];
    // Force synchronous DOM update — on iOS the touchend zone may not schedule CD.
    this.cdr.detectChanges();
    this.performHeaderItemsSearch();
    this.refocusItemSearchInput();
  }

  /** Keep the cursor in the search field after adding a chip (critical on iOS). */
  private refocusItemSearchInput(): void {
    if (!this.isItemsSearchMode) {
      return;
    }
    setTimeout(() => {
      const inputEl = this.isMobileView
        ? this.mobileSearchInputElement?.nativeElement
        : this.searchInputElement?.nativeElement;
      inputEl?.focus();
    }, 50);
  }

  private performHeaderItemsSearch() {
    const q = this.selectedItemSearchChips.join(", ").trim();
    this.hideSearchHistory();
    this.router.navigate(["/"], {
      queryParams: { q: q || null, category: "Items" },
      queryParamsHandling: "merge",
      replaceUrl: true,
    });
  }

  onItemsChipTokenEnd(event: MatChipInputEvent) {
    if (!this.isItemsSearchMode) return;
    const value = (event.value || "").trim();
    if (value) {
      this.addHeaderItemChip(value);
    } else {
      this.searchInput = "";
    }
    event.chipInput?.clear();
  }

  /**
   * iOS Safari fires blur on the chip input BEFORE the tap's click/touchend
   * reaches the suggestion dropdown.  We track whether a dropdown item is
   * being touched so we can suppress the premature chip-commit in that case.
   */
  private _iosTouchOnDropdown = false;

  /** Call on touchstart of any dropdown item (mobile + desktop dropdowns). */
  onDropdownItemTouchStart(): void {
    this._iosTouchOnDropdown = true;
    // Reset after enough time for blur + touchend to both complete
    setTimeout(() => { this._iosTouchOnDropdown = false; }, 600);
  }

  /** iOS-safe handler for tapping an item suggestion. */
  onSuggestionItemTouchEnd(item: ItemLibraryModel, event: TouchEvent): void {
    event.preventDefault(); // stop synthesised click from firing (avoids double-add)
    this._iosTouchOnDropdown = false;
    this.addHeaderItemChipFromSuggestion(item);
  }

  /** iOS-safe handler for tapping a search history item. */
  onHistoryItemTouchEnd(item: string, event: TouchEvent): void {
    event.preventDefault();
    this._iosTouchOnDropdown = false;
    this.selectSearchHistoryItem(item);
  }

  /** iOS-safe handler for tapping a @-mention suggestion. */
  onMentionTouchEnd(user: any, event: TouchEvent): void {
    event.preventDefault();
    this._iosTouchOnDropdown = false;
    this.selectUserMentionSuggestion(user);
  }

  /**
   * iOS Safari does not reliably fire keyup.enter or matChipInputTokenEnd when
   * the user taps the keyboard "Go / Search" button inside a chip input.
   * Committing the pending text on blur ensures items are added before search fires.
   * Guard: skip if the user is touching a dropdown suggestion (iOS fires blur first).
   */
  onItemsChipInputBlur(): void {
    if (!this.isItemsSearchMode) return;
    if (this._iosTouchOnDropdown) return;
    const trimmed = (this.searchInput || "").trim();
    if (trimmed) {
      this.addHeaderItemChip(trimmed);
    }
  }

  clearSearch(): void {
    this.searchInput = "";
    // On mobile, closing the search bar restores the regular header
    if (this.isMobileView) {
      this.showMobileSearch = false;
    }
    this.hideSearchHistory();
    // Clear search query params and navigate
    this.router.navigate([], {
      relativeTo: this.activateRouter,
      queryParams: { q: null },
      queryParamsHandling: "merge",
      replaceUrl: true,
    });
  }

  navigateToFlows(): void {
    this.activeHomeCategory = 'Flows';
    this.flowSearchField = 'All';
    this.currentSearchCategory = 'All';
    this.syncCategorySelectorFromCategory('All');
    this.router.navigate(["/"], {
      queryParams: { category: "All", searchField: null },
    });
  }

  navigateToUsers(): void {
    this.activeHomeCategory = 'Users';
    this.currentSearchCategory = 'Users';
    this.flowSearchField = 'All';
    this.syncCategorySelectorFromCategory('Users');
    this.router.navigate(["/"], {
      queryParams: { category: "Users" },
    });
  }

  navigateToBundles(): void {
    this.activeHomeCategory = 'Bundles';
    this.currentSearchCategory = 'Bundles';
    this.flowSearchField = 'All';
    this.syncCategorySelectorFromCategory('Bundles');
    this.router.navigate(["/"], {
      queryParams: { category: "Bundles" },
    });
  }

  navigateToItems(): void {
    this.activeHomeCategory = 'Items';
    this.flowSearchField = 'Items';
    this.currentSearchCategory = 'Items';
    this.syncCategorySelectorFromCategory('Items');
    this.router.navigate(["/"], {
      queryParams: { category: "Items" },
    });
  }

  navigateToAdminDashboard(): void {
    this.router.navigate(["/adminctrl/admindash"]);
  }

  setPageColor(page) {
    if (page == "home") {
      this.homeColor = this.brandAccent;
      this.searchColor = this.brandAccent;
      this.emoji_objectsColor = "#212427";
      this.notificationsColor = "#212427";
      this.add_circle_outlineColor = "#212427";
      this.account_circleColor = "#212427";
      this.profileColor = "#212427";
      this.personColor = "#212427";
    }

    if (page == "search") {
      this.homeColor = "#212427";
      this.searchColor = this.brandAccentImportant();
      this.emoji_objectsColor = "#212427";
      this.notificationsColor = "#212427";
      this.add_circle_outlineColor = "#212427";
      this.account_circleColor = "#212427";
      this.profileColor = "#212427";
      this.personColor = "#212427";
    }

    if (page == "bulb") {
      this.isuserdashboard = false;
      this.homeColor = "#212427";
      this.searchColor = "#212427";
      this.emoji_objectsColor = this.brandAccent;
      this.notificationsColor = "#212427";
      this.add_circle_outlineColor = "#212427";
      this.account_circleColor = "#212427";
      this.profileColor = "#212427";
      this.personColor = "#212427";
    }

    if (page == "user") {
      this.homeColor = "#212427";
      this.searchColor = "#212427";
      this.emoji_objectsColor = "#212427";
      this.notificationsColor = "#212427";
      this.add_circle_outlineColor = "#212427";
      this.account_circleColor = this.brandAccent;
      this.profileColor = "#212427";
      this.personColor = "#212427";
    }
  }

  initialize() {
    const messaging = firebase.messaging();
    messaging.usePublicVapidKey(
      "BFb9qcr5auxO24GEIH-donPWnx-cRtdIqzV5vAE1ITycrzAWMkjRS_kVAQiIFcUKW3BymKmllpbMVMblYZihzC0"
    );
    messaging.onMessage((payload) => {
      this.notificationtitle = payload.data.notificationMessage;

      // Check if notification already exists to prevent duplicates
      const existingIndex = this.notificationsarray.findIndex(
        (item) => item.notification.RowKey === payload.data.rowKey
      );

      if (
        existingIndex === -1 &&
        this.orgContextService.isNotificationVisible(payload.data)
      ) {
        // Add new notification only if it doesn't exist
        this.notificationsarray.unshift({
          notification: payload.data,
        });
      }

      // Count only unread notifications
      this.notificationscount = this.notificationsarray.filter(
        (notification) => !notification.notification.NotificationSeen
      ).length;

      if (this.notificationscount > 0) {
        this.showNotificationCount = true;
      } else {
        this.showNotificationCount = false;
      }
      this.eventEmitterService.setNotificationDetailsEvent(
        JSON.stringify(this.notificationsarray)
      );
      if (this.notificationsarray.length < this.infiniteScrollCount) {
        this.notificationsarray.forEach((element) => {
          this.tempNotifications.push(element);
        });
      } else {
        for (var i = 0; i < this.infiniteScrollCount; i++) {
          this.tempNotifications.push(this.notificationsarray[i]);
        }
      }
    });
    this.notificationscount = 0;
    
    // Check if notification permission is available and not blocked
    if ('Notification' in window) {
      const permission = Notification.permission;
      
      if (permission === 'granted') {
        // Permission granted, get token
        messaging.getToken().then((currentToken) => {
          if (currentToken) {
            localStorage.setItem("pushNotificationToken", currentToken);
          }
        }).catch((error) => {
          // Handle errors gracefully (e.g., permission blocked, service worker not available)
          console.warn('Unable to get FCM token:', error);
          // Don't throw error, just log it
        });
      } else if (permission === 'default') {
        // Permission not yet granted - do not prompt automatically
      } else {
        // Permission denied/blocked - don't attempt to get token
        console.warn('Notification permission is blocked. Push notifications will not work.');
      }
    } else {
      // Browser doesn't support notifications
      console.warn('This browser does not support notifications.');
    }
  }
  resetNotification() {
    this.notificationscount = 0;
  }

  checkLoggedIn() {
    if (this.userData === null) {
      this.router.navigate(["/login"], {
        queryParams: { returnUrl: this.router.url },
      });
    } else {
      localStorage.removeItem("ItemsRequired");
      localStorage.removeItem("flowCoverPageDetails");
      localStorage.removeItem("SupportingDocumentDocuments");
      localStorage.removeItem("SupportingDocumentHyperLinksRequired");
      localStorage.removeItem("editBundlesupportingDocumentHyperLinksIndex");
      localStorage.removeItem("BundleSupportingDocumentHyperLinksRequired");
      localStorage.removeItem("editBundleSupportingDocumentRequiredIndex");
      localStorage.removeItem("BundleSupportingDocumentDocuments");
      localStorage.removeItem("stepsCoverPageDetails");
      localStorage.removeItem("draftWord");
      localStorage.removeItem("editWord");
      localStorage.setItem("navigatebackfromcreateflow", this.location.path());
      localStorage.setItem(
        "navigatebackfromcreatebundle",
        this.location.path()
      );
      this.router.navigate(["/create-guide"]);
    }
  }

  userdashboard() {
    if (this.canViewUserDashBoard) {
      this.isuserdashboard = true;
      this.eventEmitterService.setPageDashboardProperty(true);
      this.router.navigate(["/user-dashboard/dashboard"]);
    } else {
      this.toastr.info(
        "Currently you do not have access to dashboard please request access."
      );
      this.dialog.open(AccessRoleInfoComponent, {
        width: "400px",
        disableClose: true,
      });
    }
  }

  navigateToCollaborationRequests() {
    this.router.navigate(["/collaboration-requests"]);
  }
  userAdminDashboard() {
    this.isuserdashboard = true;
    this.eventEmitterService.setPageDashboardProperty(true);
    this.router.navigate(["/adminctrl/admindash"]);
  }
  useranalytics() {
    this.eventEmitterService.setPageDashboardProperty(true);
    this.isuserdashboard = true;
    this.router.navigate(["/user-dashboard/content-analytics"]);
  }

  changepassword() {
    this.eventEmitterService.setPageDashboardProperty(false);
    this.isuserdashboard = false;
    this.router.navigate(["/user-settings/change-old-password"]);
  }

  //routerLink="/user-dashboard"

  onBellNotificationAvatarClick(notificationWrapper: any, event: Event): void {
    event.stopPropagation();
    const n = notificationWrapper?.notification;
    if (shouldAvatarOpenProfile(n)) {
      this.avatarClicked(n, "profile clicked");
    } else {
      this.avatarClicked(n, "flow clicked");
    }
  }

  getNotificationThumbnailUrl(notificationWrapper: any): string | null {
    const n = notificationWrapper?.notification;
    if (!n) {
      return null;
    }
    if (n.VideoFlowPosterImageUrl) {
      return n.VideoFlowPosterImageUrl;
    }
    if (n.FlowUrl) {
      const imageExtensions = ["jpg", "jpeg", "png", "gif", "webp", "bmp"];
      const url = String(n.FlowUrl).toLowerCase();
      if (imageExtensions.some((ext) => url.includes(ext))) {
        return n.FlowUrl;
      }
    }
    return null;
  }

  /** Flow-linked consultation or collaboration: thumbnail opens the associated flow. */
  isConsultationFlowCoverNotification(notificationWrapper: any): boolean {
    const n = notificationWrapper?.notification;
    if (!n || (n.ContentType !== "Consult" && n.ContentType !== "Collaboration")) {
      return false;
    }
    const id = (n.ContentId || "").toString().trim();
    if (!id || id.includes("@")) {
      return false;
    }
    return !!this.getNotificationThumbnailUrl(notificationWrapper);
  }

  /** Message/content area click in bell dropdown: message click takes to the request page. */
  onBellNotificationContentClick(notificationWrapper: any, event: Event): void {
    event.stopPropagation();
    const n = notificationWrapper?.notification;
    if (!n) return;
    if (n.IsNavigationDisabled) {
      this.toastr.info("This content is no longer available.");
      return;
    }
    this.markSingleBellNotificationRead(notificationWrapper);
    if (this.orgNotificationService.open(n)) {
      return;
    }
    if (n.ContentType === "Collaboration") {
      this.router.navigate(["/collaboration-requests"]);
    } else {
      this.avatarClicked(n, "flow clicked");
    }
  }

  private markSingleBellNotificationRead(notificationWrapper: any): void {
    if (
      !notificationWrapper?.notification ||
      notificationWrapper.notification.NotificationSeen
    ) {
      return;
    }

    // Build payload BEFORE optimistic update so backend receives NotificationSeen: false
    // and its guard (item.NotificationSeen != true) is satisfied.
    const transformed = {
      ...notificationWrapper.notification,
      NotificationSeen: false,
      CreatedDate:
        notificationWrapper.notification.OriginalCreatedDate ||
        new Date().toISOString(),
    };

    // Optimistic UI update
    notificationWrapper.notification.NotificationSeen = true;
    this.notificationscount = this.notificationsarray.filter(
      (item) => !item.notification.NotificationSeen
    ).length;
    this.showNotificationCount = this.notificationscount > 0;

    this.flowServiceService
      .MarkAsReadNotifications([transformed])
      .subscribe(() => {
        this.notificationscount = this.notificationsarray.filter(
          (item) => !item.notification.NotificationSeen
        ).length;
        this.showNotificationCount = this.notificationscount > 0;
      });
  }

  onBellConsultFlowCoverClick(
    notificationWrapper: any,
    event: Event
  ): void {
    if (!this.isConsultationFlowCoverNotification(notificationWrapper)) {
      return;
    }
    event.stopPropagation();
    const n = notificationWrapper.notification;
    if (n.IsNavigationDisabled) {
      this.toastr.info("This content is no longer available.");
      return;
    }
    const flowId = String(n.ContentId).trim();
    const slug = this.generateUrlSlug(n.ContentTitle || "flow");
    this.markSingleBellNotificationRead(notificationWrapper);
    localStorage.setItem("notificationflowId", flowId);
    localStorage.setItem("flow", null);
    this.router.navigate([`/guide/${slug}/${flowId}`]);
  }

  avatarClicked(notification: any, source: any) {
    console.log(notification);
    if (notification?.IsNavigationDisabled) {
      this.toastr.info("This content is no longer available.");
      return;
    }

    if (source === "profile clicked") {
      if (
        shouldAvatarOpenProfile(notification)
      ) {
        if (this.userData.emailAddress == notification.NotifierUserEmail) {
          this.router.navigate(["/user-profile"]);
        } else if (notification.NotifierUserEmail) {
          this.dataService.flowByCategorieschangeMessage(notification);
          this.router.navigate(["/view-profile"]);
        }
        return;
      }
      return;
    }

    if (this.orgNotificationService.open(notification)) {
      return;
    }

    if (notification.ContentType == "Flow") {
      const flowId =
        notification.ContentId || notification.RowKey || notification.FlowId;
      if (!flowId) {
        this.toastr.info("Flow is no longer available.");
        return;
      }
      localStorage.setItem("notificationflowId", flowId);
      localStorage.setItem("flow", null);
      this.router.navigate([
        `/guide/${this.generateUrlSlug(notification.ContentTitle)}/${
          flowId
        }`,
      ]);
    } else if (notification.ContentType == "Bundle") {
      const bundleId =
        notification.ContentId || notification.RowKey || notification.FlowId;
      if (!bundleId) {
        this.toastr.info("Bundle is no longer available.");
        return;
      }
      this.router.navigate(["/view-guide-pack/" + bundleId]);
    } else if (notification.ContentType == "User Following") {
      if (this.userData.emailAddress == notification.NotifierUserEmail) {
        //localStorage.setItem("LoggedInUser", notification.NotifierUserEmail);
        this.router.navigate(["/user-profile"]);
      } else {
        console.log(notification.NotifierUserEmail);
        this.dataService.flowByCategorieschangeMessage(notification);
        this.router.navigate(["/view-profile"]);
      }
    } else if (notification.ContentType == "Consult") {
      const path = getConsultationDashboardPath(
        notification,
        this.userData?.emailAddress
      );
      this.router.navigate([path]);
    } else if (notification.ContentType == "Collaboration") {
      this.router.navigate(["/collaboration-requests"]);
    }
  }

  generateUrlSlug(html) {
    if (!html) return "";
    return html
      .replace(/<[^>]*>/g, "") // Remove HTML tags
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "") // Remove accents (é → e, ñ → n)
      .replace(/[^a-zA-Z0-9\s-]/g, "") // Remove special characters except spaces and "-"
      .trim() // Trim spaces from start/end
      .replace(/\s+/g, "-") // Replace spaces with "-"
      .replace(/-+/g, "-") // Remove duplicate dashes
      .toLowerCase(); // Convert to lowercase
  }

  avatarProfileClicked(notification: any, source: any) {
    console.log(notification);

    if (notification.ContentType == "User Following") {
      if (this.userData.emailAddress == notification.NotifierUserEmail) {
        //localStorage.setItem("LoggedInUser", notification.NotifierUserEmail);
        this.router.navigate(["/user-profile"]);
      } else {
        console.log(notification.NotifierUserEmail);
        localStorage.setItem("LoggedInUser", notification.NotifierUserEmail);
        this.router.navigate(["/view-profile"]);
      }
      this.dataService.flowByCategorieschangeMessage(notification);
    }
  }

  aboutUsPage() {
    this.isuserdashboard = false;
    this.eventEmitterService.setPageDashboardProperty(false);
    window.scroll(0, 0);
    this.router.navigate(["/aboutus"]);
  }

  privacyPolicy() {
    this.isuserdashboard = false;
    this.eventEmitterService.setPageDashboardProperty(false);
    window.scroll(0, 0);
    this.router.navigate(["/privacypolicy"]);
  }

  terms() {
    this.isuserdashboard = false;
    this.eventEmitterService.setPageDashboardProperty(false);
    window.scroll(0, 0);
    this.router.navigate(["/termsandconditions"]);
  }

  search() {
    this.router.navigate(["/"]);
  }

  checkIsUserLoggedIn() {
    if (this.userData === null) {
      this.isuserdashboard = false;
      this.eventEmitterService.setPageDashboardProperty(false);
      this.router.navigate(["/login"], {
        queryParams: { returnUrl: this.router.url },
      });
    }
  }

  onActivate(event) {
    window.scroll(0, 0);
    document.body.scrollTop = 0;
    document.querySelector("body").scrollTo(0, 0);
    
    // Check if the activated component is a legal page
    const url = this.route.url || "";
    const isLegalPage = url.startsWith("/privacy") ||
                        url.startsWith("/privacypolicy") ||
                        url.startsWith("/tandc") ||
                        url.startsWith("/termsandconditions") ||
                        url.startsWith("/community-guidelines") ||
                        url.startsWith("/cookie-policy") ||
                        url.startsWith("/law-enforcement");
    
    // Add/remove class on body and app-main-content
    if (isLegalPage) {
      document.body.classList.add('has-legal-page');
      const mainContent = document.querySelector('.app-main-content') as HTMLElement;
      if (mainContent) {
        mainContent.classList.add('has-legal-page');
        mainContent.style.paddingTop = '0px';
      }
    } else {
      document.body.classList.remove('has-legal-page');
      const mainContent = document.querySelector('.app-main-content') as HTMLElement;
      if (mainContent) {
        mainContent.classList.remove('has-legal-page');
        mainContent.style.paddingTop = '';
      }
    }
  }

  onScroll() {
    //
    const tempNotificationLength = this.tempNotifications.length;

    if (
      this.infiniteScrollCount + this.tempNotifications.length <
      this.notificationsarray.length
    ) {
      if (tempNotificationLength < this.notificationsarray.length) {
        for (var i = 0; i < this.infiniteScrollCount; i++) {
          this.tempNotifications.push(
            this.notificationsarray[tempNotificationLength + i]
          );
        }
      }
    } else {
      var remainingNotificationCount =
        this.notificationsarray.length - this.tempNotifications.length;

      for (var i = 0; i < remainingNotificationCount; i++) {
        this.tempNotifications.push(
          this.notificationsarray[tempNotificationLength + i]
        );
      }
    }
    // Re-apply translation to newly loaded notification items
    if (this.translationService.getCurrentTranslationLanguage()) {
      setTimeout(() => this.translationService.retranslateForNewContent(), 200);
    }
  }

  generateQRCode() {
    if (this.qrcodename == "") {
      this.display = false;
      return;
    } else {
      this.value = this.qrcodename;
      this.display = true;
    }
  }
  downloadImage() {
    this.href = document.getElementsByTagName("img")[0].src;
  }

  createFlow() {
    localStorage.setItem("navigatebackfromcreateflow", this.location.path());
    localStorage.setItem("navigatebackfromcreatebundle", this.location.path());
    this.router.navigate(["/create-guide"]);
  }

  navigateToQuickCreate() {
    localStorage.setItem("navigatebackfromcreateflow", this.location.path());
    localStorage.setItem("navigatebackfromcreatebundle", this.location.path());
    // Clear any existing flow data for new creation
    localStorage.removeItem("ItemsRequired");
    localStorage.removeItem("flowCoverPageDetails");
    localStorage.removeItem("SupportingDocumentDocuments");
    localStorage.removeItem("SupportingDocumentHyperLinksRequired");
    localStorage.removeItem("stepsCoverPageDetails");
    localStorage.removeItem("draftWord");
    localStorage.removeItem("editWord");
    this.router.navigate(["/create-guide/quick"]);
  }

  navigateToManualCreate() {
    localStorage.setItem("navigatebackfromcreateflow", this.location.path());
    localStorage.setItem("navigatebackfromcreatebundle", this.location.path());
    // Clear any existing flow data for new creation
    localStorage.removeItem("ItemsRequired");
    localStorage.removeItem("flowCoverPageDetails");
    localStorage.removeItem("SupportingDocumentDocuments");
    localStorage.removeItem("SupportingDocumentHyperLinksRequired");
    localStorage.removeItem("stepsCoverPageDetails");
    localStorage.removeItem("draftWord");
    localStorage.removeItem("editWord");
    this.router.navigate(["/create-guide/manual"]);
  }

  navigateToFlowchestAiCreate() {
    localStorage.setItem("navigatebackfromcreateflow", this.location.path());
    localStorage.setItem("navigatebackfromcreatebundle", this.location.path());
    localStorage.removeItem("ItemsRequired");
    localStorage.removeItem("flowCoverPageDetails");
    localStorage.removeItem("SupportingDocumentDocuments");
    localStorage.removeItem("SupportingDocumentHyperLinksRequired");
    localStorage.removeItem("stepsCoverPageDetails");
    localStorage.removeItem("draftWord");
    localStorage.removeItem("editWord");
    this.router.navigate(["/create-guide/flowchest-ai"]);
  }

  SignOut() {
    this.isuserdashboard = false;
    this.eventEmitterService.setPageDashboardProperty(false);
    this.tokenService.clearAuthStorage();
    this.data.changeMessagebool(false);
    // Clear in-memory auth state
    this.userData = null;
    this.isUserLoggedIn = false;
    this.isLogin = false;
    this.userDisplayName = null;
    this.userDisplayEmail = null;
    this.premissionToActions = null;
    this.canCreateFlowOrBundle = false;
    this.canViewNotification = false;
    this.canViewUserDashBoard = false;
    // Notify the rest of the app that the user has logged out
    this.eventEmitterService.setLoggedInUserProperty(false);
    this.clearOrgContextUi();
    this.showToastForLogout();
    this.profilePicture = null;
    if (window.location.pathname == "/user-profile") {
      this.router.navigate(["/"]);
    } else {
      window.location.reload();
    }

    this.authService.logout();
  }

  private getStoredLoggedInUser(): any {
    const raw = localStorage.getItem("LoggedInUser");
    if (!raw || raw === "null") {
      return null;
    }
    try {
      const parsed = JSON.parse(raw);
      return parsed && typeof parsed === "object" ? parsed : null;
    } catch {
      return null;
    }
  }

  private restoreAuthSessionFromStorage(): void {
    if (this.userData == null || !this.tokenService.hasUsableToken()) {
      return;
    }
    this.isUserLoggedIn = true;
    this.isLogin = true;
    localStorage.setItem("isLogin", "Yes");
    this.data.changeMessagebool(true);
    this.applyProfilePictureFromStoredUser();
  }

  private applyProfilePictureFromStoredUser(): void {
    const pic =
      this.userData?.profilePicUrl || this.userData?.ProfilePicUrl || "";
    if (!pic) {
      return;
    }
    this.profilePicture = pic;
    this.showDefaultImage = false;
    this.eventEmitterService.setProfilePictureEvent(this.profilePicture);
    this.cdr.markForCheck();
  }

  getProfileUser(): void {
    this.userData = this.getStoredLoggedInUser();

    if (this.userData != null) {
      this.userDisplayName = this.userData.firstName;
      this.noResultReturned = true;
      //
      this.showNotificationCount = false;
      this.userserviceService.getProfileUser().subscribe((data) => {
        if (
          data.userData.profilePicUrl === "" ||
          data.userData.profilePicUrl == null
        ) {
          this.showDefaultImage = true;
          this.profilePicture = null;
        } else {
          this.showDefaultImage = false;
          this.profilePicture = data.userData.profilePicUrl;
          this.eventEmitterService.setProfilePictureEvent(this.profilePicture);
        }
        if (this.userData) {
          this.userData.profilePicUrl = data.userData.profilePicUrl || null;
          localStorage.setItem("LoggedInUser", JSON.stringify(this.userData));
        }
        this.email = data.userData.emailAddress;
        this.phone = data.userData.phoneNumber;
        this.info = data.userData.info;
        this.website = data.userData.website;
        this.userDisplayName = this.uname = data.userData.userName;
        this.name = data.userData.firstName;
        const profileTheme = (data.userData.selectedTheme || "")
          .toString()
          .toLowerCase();
        if (profileTheme === "dark" || profileTheme === "light") {
          this.themePreferenceService.setTheme(profileTheme, true);
        }
        if (this.userData) {
          this.userData.selectedTheme = this.selectedThemeMode;
          const previousEffectiveRole =
            this.permissionsService.resolveEffectiveRole(this.userData);
          // Sync role fields from profile so admin role changes apply without re-login
          if (data.userData.userRole != null) {
            this.userData.userRole = data.userData.userRole;
          }
          if (data.userData.userType != null) {
            this.userData.userType = data.userData.userType;
          }
          if (data.userData.effectivePlanId != null) {
            this.userData.effectivePlanId = data.userData.effectivePlanId;
          }
          this.isAdmin = isSiteAdminUser(this.userData);
          localStorage.setItem("LoggedInUser", JSON.stringify(this.userData));

          const nextEffectiveRole =
            this.permissionsService.resolveEffectiveRole(this.userData);
          if (previousEffectiveRole !== nextEffectiveRole) {
            this.refreshPermissionsFromServer(this.userData);
          } else {
            // Role unchanged — still re-apply shell flags (e.g. plan fields updated)
            this.checkPermissions();
          }
        }

        this.noResultReturned = false;
        this.subscriptionUsageAlertService.checkAndNotify();
        this.trialStateService.refresh().subscribe();
        //
        // this.getnotification();
      });
    }
  }

  setallblue(selectedIcon) {
    this.homebgColor = "white";
    this.homeColor = "#212427";

    this.searchbgColor = "white";
    this.searchColor = "#212427";

    this.emoji_objectsbgColor = "white";
    this.emoji_objectsColor = "#212427";

    this.add_circle_outlinebgColor = "white";
    this.add_circle_outlineColor = "#212427";

    this.notificationsbgColor = "white";
    this.notificationsColor = "#212427";

    this.profilebgColor = "white";
    this.profileColor = "#212427";

    this.menubgColor = "white";
    this.menuColor = "#212427";

    this.account_circlebgColor = "white";
    this.account_circleColor = "#212427";

    this.personbgColor = "white";
    this.personColor = "#212427";

    this.setSelectedIconToBlue(selectedIcon);
  }

  setSelectedIconToBlue(selectedIcon) {
    switch (selectedIcon) {
      case "home":
        this.isuserdashboard = false;
        this.homebgColor = "white";
        this.homeColor = this.brandAccentImportant();
        break;
      case "search":
        this.isuserdashboard = false;
        this.searchbgColor = "white";
        this.searchColor = this.brandAccentImportant();
        this.search();
        break;
      case "emoji_objects":
        this.isuserdashboard = false;
        this.emoji_objectsbgColor = "white";
        this.emoji_objectsColor = this.brandAccentImportant();
        this.router.navigate(["/bulbguide"]);
        break;
      case "add_circle_outline":
        this.isuserdashboard = false;
        this.add_circle_outlinebgColor = "white";
        this.add_circle_outlineColor = this.brandAccentImportant();
        this.add_circle_outlineSize = "30px";
        break;
      case "notifications":
        this.isuserdashboard = false;
        this.notificationsbgColor = "white";
        this.notificationsColor = this.brandAccentImportant();
        this.checkIsUserLoggedIn();
        // Navigation is handled in iconClicked method
        break;

      case "profile":
        this.isuserdashboard = false;
        this.profilebgColor = "white";
        this.profileColor = this.brandAccentImportant();
        this.profile_outlineSize = "30px";
        this.checkIsUserLoggedIn();
        localStorage.setItem("draftTabIndex", "0");
        break;

      case "menu":
        this.menubgColor = "white";
        this.menuColor = this.brandAccentImportant();

        break;

      case "account":
        this.account_borderRadius = "50%";
        this.account_border = `3px solid ${this.brandAccent} !important`;
        this.account_circlebgColor = "white";
        this.account_circleColor = this.brandAccentImportant();

        break;
      case "person":
        this.personbgColor = "white";
        this.personColor = this.brandAccent;

        break;
    }
  }

  openDialog() {
    // Always keep Create visible for logged-in users; gate access here.
    if (this.userData != null) {
      this.checkPermissions();
    }
    if (this.userData != null && this.canCreateFlowOrBundle) {
      localStorage.removeItem("ItemsRequired");
      localStorage.removeItem("flowCoverPageDetails");
      localStorage.removeItem("SupportingDocumentDocuments");
      localStorage.removeItem("SupportingDocumentHyperLinksRequired");
      localStorage.removeItem("stepsCoverPageDetails");
      localStorage.removeItem("draftWord");
      localStorage.removeItem("editWord");
      const dialogRef = this.dialog.open(BundledialogComponent, {
        panelClass: "dialoguebox",
      });

      dialogRef.afterClosed().subscribe((result) => {
        this.eventEmitterService.setUserProfileCreateIconClickedEvent("");
        if (result === "bundle") {
          localStorage.setItem(
            "navigatebackfromcreatebundle",
            this.location.path()
          );
          localStorage.removeItem("createbundledetails");
          localStorage.removeItem("addbundleselectedflows");
          this.eventEmitterService.setUserProfileCreateIconClickedEvent(
            "add_circle_outline"
          );
          this.router.navigate(["/create-guide-pack"]);
        } else if (result === "flowchest-ai-create" || result === "quick-create") {
          console.log("Navigating to Smart Create page...");
          this.eventEmitterService.setUserProfileCreateIconClickedEvent(
            "add_circle_outline"
          );
          setTimeout(() => {
            this.router.navigate(["/create-guide/quick"]).then(
              (success) => {
                console.log("Navigation to Smart Create successful:", success);
              },
              (error) => {
                console.error("Navigation error:", error);
                window.location.href = "/create-guide/quick";
              }
            );
          }, 100);
        } else if (result === "manual-create") {
          console.log("Navigating to Manual Create page...");
          this.eventEmitterService.setUserProfileCreateIconClickedEvent(
            "add_circle_outline"
          );
          // Navigate to manual create
          setTimeout(() => {
            this.router.navigate(["/create-guide/manual"]).then(
              (success) => {
                console.log("Navigation to Manual Create successful:", success);
              },
              (error) => {
                console.error("Navigation error:", error);
                // Fallback to window location if router fails
                window.location.href = "/create-guide/manual";
              }
            );
          }, 100);
        } else if (result === "flow") {
          localStorage.setItem(
            "navigatebackfromcreateflow",
            this.location.path()
          );
          this.eventEmitterService.setUserProfileCreateIconClickedEvent(
            "add_circle_outline"
          );
          // Navigate to selection page to choose Quick Create or Manual Create
          this.router.navigate(["/create-guide/selection"]);
        } else {
          this.eventEmitterService.setUserProfileCreateIconClickedEvent("");
          window.location.reload();
        }
      });
    } else if (this.userData != null && !this.canCreateFlowOrBundle) {
      const orgDenied =
        this.orgContextService.snapshot.loaded &&
        this.orgContextService.isOrganizationMode() &&
        !this.orgContextService.canCreateOrgContent();
      this.toastr.info(
        orgDenied
          ? "Your organization role does not allow creating guides or guide packs."
          : "Currently you do not have access to create flow/bundle please request access to admin"
      );
      this.dialog.open(AccessRoleInfoComponent, {
        width: "400px",
        disableClose: true,
      });
    } else {
      this.router.navigate(["/login"], {
        queryParams: { returnUrl: this.router.url },
      });
    }
  }

  iconClicked(icon) {
    if (icon == "notifications") {
      // Check if user is logged in
      if (this.userData === null) {
        this.router.navigate(["/login"], {
          queryParams: { returnUrl: "/notifications" },
        });
        return;
      }

      // Check permissions
      if (!this.canViewNotification) {
        this.toastr.info(
          "Currently you do not have access to view notifications please request access to admin"
        );
        this.dialog.open(AccessRoleInfoComponent, {
          width: "400px",
          disableClose: true,
        });
        return;
      }

      // Navigate to notifications page
      this.setallblue(icon);
      this.router.navigate(["/notifications"]);
      return;
    } else {
      this.setallblue(icon);
    }
  }
  timeAgo(createdDate: string): string {
    const currentTime = new Date();
    const notificationTime = new Date(createdDate);

    // Check if the date is valid
    if (isNaN(notificationTime.getTime())) {
      console.warn("Invalid date provided to timeAgo:", createdDate);
      return "Unknown time";
    }

    const timeDifference = currentTime.getTime() - notificationTime.getTime(); // Difference in milliseconds

    // Handle negative time differences (future dates)
    if (timeDifference < 0) {
      return "Just now";
    }

    // Convert time difference to different time units
    const seconds = Math.floor(timeDifference / 1000);
    const minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);
    const weeks = Math.floor(days / 7);
    const months = Math.floor(days / 30); // Rough approximation of months
    const years = Math.floor(days / 365); // Rough approximation of years

    if (years > 0) {
      return `${years} year${years > 1 ? "s" : ""} ago`;
    } else if (months > 0) {
      return `${months} month${months > 1 ? "s" : ""} ago`;
    } else if (weeks > 0) {
      return `${weeks} week${weeks > 1 ? "s" : ""} ago`;
    } else if (days > 0) {
      return `${days} day${days > 1 ? "s" : ""} ago`;
    } else if (hours > 0) {
      return `${hours} hour${hours > 1 ? "s" : ""} ago`;
    } else if (minutes > 0) {
      return `${minutes} minute${minutes > 1 ? "s" : ""} ago`;
    } else {
      return `${seconds} second${seconds > 1 ? "s" : ""} ago`;
    }
  }
  parseCreatedDate = (createdDate) => {
    const currentDate = new Date();

    const [value, unit] = createdDate.split(" ");

    switch (unit) {
      case "minutes":
      case "minute":
        currentDate.setMinutes(currentDate.getMinutes() - parseInt(value));
        break;
      case "hours":
      case "hour":
        currentDate.setHours(currentDate.getHours() - parseInt(value));
        break;
      case "days":
      case "day":
        currentDate.setDate(currentDate.getDate() - parseInt(value));
        break;
      case "weeks":
      case "week":
        currentDate.setDate(currentDate.getDate() - parseInt(value) * 7);
        break;
      default:
        console.log("Unhandled unit: " + unit);
    }

    return currentDate.toISOString(); // Returns timestamp in ISO format
  };
  getnotification() {
    // Notifications are scoped to the account type; wait until it is resolved
    // (applyOrgContextUiFromSnapshot fetches once the org context loads).
    if (!this.userData?.emailAddress || !this.orgContextService.snapshot.loaded) {
      return;
    }
    const scopeKey = this.orgContextService.accountScopeKey();
    this.notificationsScopeKey = scopeKey;
    this.noResultReturned = true;
    this.notificationsarray = []; // Clear existing notifications

    var flowQueryModel = new FlowQueryModel({
      userEmail: this.userData.emailAddress,
      pageIndex: 0,
    });

    this.flowServiceService
      .getNotifications(flowQueryModel)
      .subscribe((data) => {
        // Account type changed while this request was in flight.
        if (scopeKey !== this.notificationsScopeKey) {
          return;
        }
        this.isthereanyNotifications = true;
        this.noResultReturned = false;
        //
        if (data != null) {
          data.forEach((element) => {
            console.log(element);
            if (!this.orgContextService.isNotificationVisible(element)) {
              return;
            }

            // Check if notification already exists to prevent duplicates
            const existingIndex = this.notificationsarray.findIndex(
              (item) => item.notification.RowKey === element.rowKey
            );

            if (existingIndex === -1) {
              // Add notification only if it doesn't exist
              var notification = {
                notification: {
                  CreatedDate: this.timeAgo(element.createdDate),
                  OriginalCreatedDate: element.createdDate, // Store original date for proper sorting
                  ProfilePicUrl: element.notifierProfilePicUrl,
                  NotifierUserName: element.notifierUserName,
                  NotificationSeen: element.notificationSeen,
                  Message: element.message,
                  ContentId: element.contentId,
                  ContentTitle: element.contentTitle,
                  FlowUrl: element.flowUrl,
                  FlowId: element.notifierCustomerId,
                  ContentType: element.contentType,
                  ConsultationNavTarget: element.consultationNavTarget,
                  IsNavigationDisabled: !!element.isNavigationDisabled,
                  NotifierUserEmail: element.notifierUserEmail,
                  VideoFlowPosterImageUrl: element.videoFlowPosterImageUrl,
                  OrganizationId: element.organizationId,
                  NavigationUrl: element.navigationUrl,
                  PartitionKey: element.partitionKey,
                  RowKey: element.rowKey,
                },
              };
              console.log(notification);
              this.notificationsarray.push(notification);
            } else {
              // Update existing notification if it's already in the array
              this.notificationsarray[
                existingIndex
              ].notification.NotificationSeen = element.notificationSeen;
            }
          });

          // Sort notifications by actual date (newest first) before categorization
          this.notificationsarray.sort((a, b) => {
            const dateA = this.parseRelativeTime(a.notification.CreatedDate);
            const dateB = this.parseRelativeTime(b.notification.CreatedDate);
            return dateB.getTime() - dateA.getTime(); // Newest first
          });

          this.categorizeNotifications();
          this.notificationscount = this.notificationsarray.filter(
            (notification) => !notification.notification.NotificationSeen
          ).length;
          if (this.notificationscount > 0) {
            this.showNotificationCount = true;
          } else {
            this.showNotificationCount = false;
          }
          console.log(this.notificationscount);
          console.log(this.notificationsarray);
        } else {
          this.isthereanyNotifications = false;
        }
      });
  }
  scheduleReadNotification(): void {
    // Use a delay of 1 minute 30 seconds (90,000 milliseconds) before calling ReadNotification
    setTimeout(() => {
      this.ReadNotification();
    }, 90000); // 90 seconds delay
  }

  categorizeNotifications() {
    this.notificationsToday = this.notificationsarray.filter((notification) =>
      this.isToday(
        this.parseRelativeTime(notification.notification.CreatedDate)
      )
    );
    console.log(this.notificationsToday);

    this.notificationsYesterday = this.notificationsarray.filter(
      (notification) =>
        this.isYesterday(
          this.parseRelativeTime(notification.notification.CreatedDate)
        )
    );
    console.log(this.notificationsYesterday);

    this.notificationsThisWeek = this.notificationsarray.filter(
      (notification) => {
        const notificationDate = this.parseRelativeTime(
          notification.notification.CreatedDate
        );
        return (
          this.isThisWeek(notificationDate) &&
          !this.isToday(notificationDate) &&
          !this.isYesterday(notificationDate)
        );
      }
    );
    console.log(this.notificationsThisWeek);

    this.notificationsOlder = this.notificationsarray.filter((notification) => {
      const notificationDate = this.parseRelativeTime(
        notification.notification.CreatedDate
      );
      return (
        this.isOlder(notificationDate) && !this.isThisWeek(notificationDate)
      );
    });
    console.log(this.notificationsOlder);
  }

  parseRelativeTime(relativeTime: string): Date {
    const time = new Date();
    const numberPattern = /\d+/g;
    const value = parseInt(relativeTime.match(numberPattern)?.[0] || "0", 10);

    // Handle different time units
    if (relativeTime.includes("second")) {
      time.setSeconds(time.getSeconds() - value);
    } else if (relativeTime.includes("minute")) {
      time.setMinutes(time.getMinutes() - value);
    } else if (relativeTime.includes("hour")) {
      time.setHours(time.getHours() - value);
    } else if (relativeTime.includes("day")) {
      time.setDate(time.getDate() - value);
    } else if (relativeTime.includes("week")) {
      time.setDate(time.getDate() - value * 7);
    } else if (relativeTime.includes("month")) {
      time.setMonth(time.getMonth() - value);
    } else if (relativeTime.includes("year")) {
      time.setFullYear(time.getFullYear() - value);
    } else {
      // If we can't parse the relative time, try to parse as ISO date
      try {
        const parsedDate = new Date(relativeTime);
        if (!isNaN(parsedDate.getTime())) {
          return parsedDate;
        }
      } catch (e) {
        console.warn("Could not parse date:", relativeTime);
      }
      // Fallback to current time if parsing fails
      return new Date();
    }

    return time;
  }

  isToday(date: Date): boolean {
    return date.toDateString() === this.today.toDateString();
  }

  isYesterday(date: Date): boolean {
    return date.toDateString() === this.yesterday.toDateString();
  }

  isThisWeek(date: Date): boolean {
    return date > this.thisWeekStart && date <= this.today;
  }

  isOlder(date: Date): boolean {
    return date < this.thisWeekStart;
  }
  ReadNotification(): void {
    const transformedNotifications = this.notificationsarray.map((item) => {
      const notification = item.notification;
      return {
        ...notification,
        CreatedDate: this.parseCreatedDate(notification.CreatedDate),
      };
    });
    console.log(transformedNotifications);
    this.noResultReturned = true;
    console.log(this.noResultReturned);
    console.log(this.notificationsarray);
    this.flowServiceService
      .MarkAsReadNotifications(transformedNotifications)
      .subscribe((data) => {
        this.isthereanyNotifications = true;
        this.noResultReturned = false;
        //
        if (data != null) {
          console.log("success");
          // Update notification count to show only unread notifications
          this.notificationscount = this.notificationsarray.filter(
            (notification) => !notification.notification.NotificationSeen
          ).length;

          if (this.notificationscount > 0) {
            this.showNotificationCount = true;
          } else {
            this.showNotificationCount = false;
          }
        } else {
          this.isthereanyNotifications = false;
        }
      });
  }
  toggleMobileSearch(): void {
    if (this.isMobileView) {
      this.showMobileSearch = !this.showMobileSearch;
      if (this.showMobileSearch) {
        // Focus the search input after a short delay to ensure it's rendered
        setTimeout(() => {
          if (this.mobileSearchInputElement && this.mobileSearchInputElement.nativeElement) {
            this.mobileSearchInputElement.nativeElement.focus();
          }
        }, 100);
      } else {
        // Closing: behave like desktop cancel — clear chips then delegate to
        // clearSearch() which clears input, hides the bar, clears the route q
        // param, and restores the tab's original data.
        this.selectedItemSearchChips = [];
        this.clearSearch();
      }
    }
  }
  
  openAuthModal(modalType: AuthModalType): void {
    // Store current route before opening modal
    const currentRoute = this.router.url || '/';
    this.authModalService.openModal(modalType, currentRoute);
  }

  private loadOrgContext(): void {
    if (!this.tokenService.hasUsableToken()) {
      return;
    }
    if (!this.orgContextWatchSub) {
      this.orgContextWatchSub = this.orgContextService.watch().subscribe(() => {
        this.applyOrgContextUiFromSnapshot();
      });
    }
    // Mode + preferred org are resolved inside OrgContextService.load()
    this.orgContextService.load().subscribe();
  }

  /** Keep shell branding / switcher in sync when membership changes (e.g. invite accept). */
  private applyOrgContextUiFromSnapshot(): void {
    const snap = this.orgContextService.snapshot;
    if (!snap?.loaded) {
      return;
    }
    const inOrgMode = this.orgContextService.isOrganizationMode();
    const branding = inOrgMode ? snap.branding : null;
    this.orgLogoUrl = branding?.logoUrl || null;
    this.hasOrgBranding = !!(
      branding?.logoUrl ||
      branding?.primaryColor ||
      branding?.accentColor ||
      branding?.surfaceColor
    );
    const orgOptions = this.orgContextService.organizationOptions();
    const memberships =
      snap.memberships || (snap as any).Memberships || [];
    this.accountTypeOrgOptions = orgOptions.map((org) => ({
      ...org,
      roleLabel: this.highestOrgRoleLabel(org.organizationId, memberships),
    }));
    this.selectedAccountTypeValue = inOrgMode
      ? snap.activeOrganization?.organizationId ||
        snap.activeOrganization?.OrganizationId ||
        "public"
      : "public";
    this.orgName = inOrgMode
      ? snap.activeOrganization?.name ||
        snap.activeOrganization?.Name ||
        null
      : orgOptions.length
      ? "Public"
      : null;
    this.orgApplications = inOrgMode ? snap.applications || [] : [];
    this.orgTeams = inOrgMode ? snap.teams || [] : [];
    this.activeApplicationId = inOrgMode
      ? snap.activeApplicationId || null
      : null;
    this.activeTeamId = inOrgMode ? snap.activeTeamId || null : null;
    // Show Public ↔ Organization switcher whenever the user has any org membership
    // or an active organization (do not hide on transient empty option lists).
    this.showOrgSwitcher =
      this.accountTypeOrgOptions.length > 0 ||
      memberships.length > 0 ||
      !!(
        snap.activeOrganization?.organizationId ||
        snap.activeOrganization?.OrganizationId
      );
    this.showPublicAccountType = true;
    const activeOrgId =
      this.selectedAccountTypeValue !== "public"
        ? this.selectedAccountTypeValue
        : null;
    this.orgRoleSummary =
      inOrgMode && activeOrgId
        ? this.highestOrgRoleLabel(activeOrgId, memberships)
        : null;
    const seenChipLabels = new Set<string>();
    this.orgMembershipChips = inOrgMode && activeOrgId
      ? memberships
          .filter(
            (m: any) =>
              (!m.status || String(m.status).toLowerCase() === "active") &&
              (m.organizationId || m.OrganizationId) === activeOrgId
          )
          .map((m: any) => {
            const role = m.role || m.Role || "";
            const scopeLabel =
              m.teamName ||
              m.TeamName ||
              m.applicationName ||
              m.ApplicationName ||
              "";
            const roleLabel = this.formatOrgRoleLabel(role);
            const jobRole = m.jobRole || m.JobRole || "";
            const label = [roleLabel, scopeLabel, jobRole]
              .filter(Boolean)
              .join(" · ");
            return {
              role,
              jobRole,
              label: label || roleLabel || "Member",
            };
          })
          .filter((chip) => {
            const key = chip.label.toLowerCase();
            if (seenChipLabels.has(key)) return false;
            seenChipLabels.add(key);
            return true;
          })
      : [];
    this.checkPermissions();
    this.refreshNavBrandColors();
    // Re-fetch notifications for the resolved account type (after login / switch).
    if (
      this.userData?.emailAddress &&
      this.tokenService.hasUsableToken() &&
      this.orgContextService.accountScopeKey() !== this.notificationsScopeKey
    ) {
      this.getnotification();
    }
    this.cdr.markForCheck();
    this.cdr.detectChanges();
  }

  onShellAccountTypeChange(value: string): void {
    if (!value || value === this.selectedAccountTypeValue) return;
    const done = () => {
      this.applyOrgContextUiFromSnapshot();
      this.checkPermissions();
      this.cdr.detectChanges();
      // Hard reload so home/search remount and refetch under the new account mode.
      window.location.assign("/");
    };
    if (value === "public") {
      this.orgContextService.enterPublicMode().subscribe({
        next: () => done(),
        error: () => this.cdr.detectChanges(),
      });
    } else {
      this.orgContextService.enterOrganizationMode(value).subscribe({
        next: () => done(),
        error: () => this.cdr.detectChanges(),
      });
    }
  }

  /** Label shown in the profile menu for the current account type. */
  get accountTypeMenuLabel(): string {
    if (this.selectedAccountTypeValue === "public") {
      return "Public";
    }
    const match = this.accountTypeOrgOptions.find(
      (o) => o.organizationId === this.selectedAccountTypeValue
    );
    return match?.organizationName || this.orgName || "Organization";
  }

  /** Friendly label for an org access role key (uses org terminology when present). */
  private formatOrgRoleLabel(role: string | null | undefined): string {
    if (!role) return "";
    const accessRoles =
      this.orgContextService.snapshot.terminology?.accessRoles || [];
    const custom = (accessRoles as any[]).find(
      (r) =>
        String(r?.key || "").toLowerCase() === String(role).toLowerCase()
    );
    if (custom?.displayName) return String(custom.displayName).trim();
    const known: Record<string, string> = {
      OrgAdmin: "Org Admin",
      AppAdmin: "App Admin",
      TeamAdmin: "Team Admin",
      Worker: "Worker",
      Author: "Author",
      Reviewer: "Reviewer",
      Approver: "Approver",
    };
    if (known[role]) return known[role];
    return role.replace(/([a-z])([A-Z])/g, "$1 $2");
  }

  /** Highest-privilege active role label for the given organization. */
  private highestOrgRoleLabel(
    organizationId: string,
    memberships: any[]
  ): string | null {
    if (!organizationId) return null;
    const roleRank: Record<string, number> = {
      OrgAdmin: 70,
      AppAdmin: 60,
      TeamAdmin: 50,
      Approver: 40,
      Reviewer: 30,
      Author: 20,
      Worker: 10,
    };
    let bestRole: string | null = null;
    let bestRank = -1;
    for (const m of memberships || []) {
      if (m.status && String(m.status).toLowerCase() !== "active") continue;
      if ((m.organizationId || m.OrganizationId) !== organizationId) continue;
      const role = String(m.role || m.Role || "");
      if (!role) continue;
      const rank = roleRank[role] ?? 1;
      if (rank > bestRank) {
        bestRank = rank;
        bestRole = role;
      }
    }
    return bestRole ? this.formatOrgRoleLabel(bestRole) : null;
  }

  /** Live org brand hex from CSS (set by OrgContextService.applyBranding). */
  get brandAccent(): string {
    try {
      if (typeof document !== "undefined") {
        const v = getComputedStyle(document.documentElement)
          .getPropertyValue("--fc-brand")
          .trim();
        if (v) return v;
      }
    } catch {
      /* ignore */
    }
    return "#5ea1d8";
  }

  private brandAccentImportant(): string {
    return `${this.brandAccent} !important`;
  }

  /** Re-apply brand tint to any nav icon currently using the old Flowchest blue. */
  private refreshNavBrandColors(): void {
    const brand = this.brandAccent;
    const important = this.brandAccentImportant();
    const isBrand = (c: any) =>
      typeof c === "string" &&
      (c.includes("#5ea1d8") ||
        c.includes("#5EA1D8") ||
        c.includes("var(--fc-brand") ||
        (brand && c.includes(brand)));

    if (isBrand(this.homeColor)) this.homeColor = important;
    if (isBrand(this.searchColor)) this.searchColor = important;
    if (isBrand(this.emoji_objectsColor)) this.emoji_objectsColor = brand;
    if (isBrand(this.add_circle_outlineColor))
      this.add_circle_outlineColor = important;
    if (isBrand(this.notificationsColor)) this.notificationsColor = important;
    if (isBrand(this.profileColor)) this.profileColor = important;
    if (isBrand(this.menuColor)) this.menuColor = important;
    if (isBrand(this.account_circleColor)) this.account_circleColor = important;
    if (isBrand(this.personColor)) this.personColor = brand;
    if (
      typeof this.account_border === "string" &&
      this.account_border.includes("#5ea1d8")
    ) {
      this.account_border = `3px solid ${brand} !important`;
    }
  }

  private clearOrgContextUi(): void {
    this.orgContextService.clear();
    this.notificationsScopeKey = null;
    this.orgLogoUrl = null;
    this.orgName = null;
    this.hasOrgBranding = false;
    this.orgApplications = [];
    this.orgTeams = [];
    this.activeApplicationId = null;
    this.activeTeamId = null;
    this.showOrgSwitcher = false;
    this.showPublicAccountType = true;
    this.orgMembershipChips = [];
    this.orgRoleSummary = null;
    this.showOrgJoinDiscover = false;
  }

  get filteredOrgTeams(): any[] {
    if (!this.activeApplicationId) return this.orgTeams || [];
    return (this.orgTeams || []).filter(
      (t) => t.applicationId === this.activeApplicationId
    );
  }

  onOrgApplicationChange(applicationId: string | null): void {
    this.orgContextService.setActiveApplication(applicationId);
    this.activeApplicationId = applicationId;
    this.activeTeamId = this.orgContextService.snapshot.activeTeamId || null;
    if (this.router.url === "/" || this.router.url.startsWith("/?")) {
      window.location.reload();
    }
  }

  onOrgTeamChange(teamId: string | null): void {
    this.orgContextService.setActiveTeam(teamId);
    this.activeTeamId = teamId;
    if (this.router.url === "/" || this.router.url.startsWith("/?")) {
      window.location.reload();
    }
  }

  /** Open auth UI in the overlay; keep URL on the auth route (home is guarded). */
  private openAuthModalFromRoute(modalType: AuthModalType): void {
    const url = this.router.url || '/';
    const returnUrlParam = this.router.parseUrl(url).queryParams['returnUrl'];
    const returnUrl =
      (typeof returnUrlParam === 'string' && returnUrlParam) ||
      this.authModalService.getReturnUrl() ||
      '/';

    this.authModalService.openModal(
      modalType,
      returnUrl === '/login' ? '/' : returnUrl
    );
  }
  
  closeAuthModal(): void {
    this.authModalService.closeModal();
  }
}
